// This file is auto-generated by @hey-api/openapi-ts
export const PaginationMetaFieldsSchema = {
    type: "object",
    properties: {
        current_page: {
            type: "integer",
            description: "Current page",
            example: 1,
        },
        first_page_url: {
            type: "string",
            description: "First page url",
            example: "https://des-evo/api/domain?page=1",
        },
        from: {
            type: "integer",
            description: "From",
            nullable: true,
            example: 1,
        },
        last_page: {
            type: "integer",
            description: "Last page",
            example: 1,
        },
        last_page_url: {
            type: "string",
            description: "Last page url",
            example: "https://des-evo/api/domain?page=1",
        },
        next_page_url: {
            type: "string",
            description: "Next page url",
            nullable: true,
        },
        path: {
            type: "string",
            description: "Path",
            example: "https://des-evo/api/domain",
        },
        per_page: {
            type: "integer",
            description: "Per page",
            example: 15,
        },
        prev_page_url: {
            type: "string",
            description: "Prev page url",
            nullable: true,
            example: "https://des-evo/api/domain?page=1",
        },
        to: {
            type: "integer",
            description: "To",
            nullable: true,
            example: 1,
        },
        total: {
            type: "integer",
            description: "Total",
            example: 1,
        },
    },
};
export const EmailValidationSchema = {
    required: ["email", "is_valid"],
    type: "object",
    properties: {
        email: {
            type: "string",
            description: "The email address to validate",
            example: "johndoe@gmail.com",
        },
        is_valid: {
            type: "boolean",
            description: "Whether the email address is valid",
            example: true,
        },
        message: {
            type: "string",
            description: "The validation message",
            nullable: true,
            example: "Email is not valid",
        },
    },
};
export const TrackingSchemaSchema = {
    allOf: [
        {
            type: "object",
            properties: {
                channel_id: {
                    type: "string",
                    description: "Channel ID",
                    nullable: true,
                    example: "Media",
                },
                channel_type: {
                    type: "string",
                    description: "Channel type",
                    nullable: true,
                    example: "Offline",
                },
                country: {
                    type: "string",
                    description: "Country",
                    nullable: true,
                    example: "PL",
                },
                campaign_id: {
                    type: "string",
                    description: "Campaign ID",
                    nullable: true,
                    example: "offline_registration_promotion_discount_50",
                },
                content_id: {
                    type: "string",
                    description: "Content ID",
                    nullable: true,
                    example: "Clerk_Registration",
                },
                guided_trial: {
                    type: "boolean",
                    description: "Guided trial",
                    nullable: true,
                    example: true,
                },
                program_id: {
                    type: "string",
                    description: "Program ID",
                    nullable: true,
                    example: "prog1",
                },
            },
            nullable: true,
        },
    ],
};
export const CommonFieldsSchema = {
    type: "object",
    properties: {
        id: {
            type: "integer",
            description: "Record identifier",
            format: "int64",
            example: 1,
        },
        created_at: {
            type: "string",
            description: "Record creation time",
            format: "date-time",
            example: "2021-02-12T08:51:50.0000000+00:00",
        },
        updated_at: {
            type: "string",
            description: "Record update time",
            format: "date-time",
            example: "2021-02-12T08:51:50.0000000+00:00",
        },
    },
};
export const PaginationLinksFieldsSchema = {
    type: "object",
    properties: {
        url: {
            type: "string",
            description: "Link url",
            nullable: true,
            example: "https://des-evo/api/domain?page=1",
        },
        label: {
            type: "string",
            description: "Link label",
            example: "< Previous",
        },
        active: {
            type: "boolean",
            description: "Link is active or not",
            example: true,
        },
    },
};
export const ErrorMessageFieldsSchema = {
    required: ["error_code"],
    type: "object",
    properties: {
        message: {
            type: "string",
            example: "Some error",
        },
        error_code: {
            type: "string",
            example: "domain::error_code",
        },
    },
};
export const Public_Platform_ConfigurationSchema = {
    allOf: [
        {
            type: "object",
            properties: {
                code: {
                    type: "string",
                    example: "ploom-countries-prod",
                },
                name: {
                    type: "string",
                    example: "all country configurations",
                },
                data: {
                    type: "array",
                    items: {
                        type: "object",
                    },
                    example: [
                        {
                            code: "IT",
                            data: {
                                MarketUrl: "https://ploom.it/",
                                DeviceRegistrationUrl: "https://ploom.it/",
                            },
                        },
                        {
                            code: "UK",
                            data: {
                                MarketUrl: "https://ploom.co.uk/",
                                DeviceRegistrationUrl: "https://www.ploom.co.uk/en/auth#/register",
                            },
                        },
                    ],
                },
            },
        },
    ],
};
export const Platform_ConfigurationSchema = {
    allOf: [
        {
            type: "object",
            properties: {
                code: {
                    type: "string",
                    example: "test_code",
                },
                name: {
                    type: "string",
                    example: "test",
                },
                public: {
                    type: "boolean",
                    example: true,
                },
                data: {
                    type: "array",
                    items: {
                        type: "object",
                    },
                    example: [
                        {
                            code: "IT",
                            data: {
                                MarketUrl: "https://ploom.it/",
                                DeviceRegistrationUrl: "https://ploom.it/",
                            },
                        },
                        {
                            code: "UK",
                            data: {
                                MarketUrl: "https://ploom.co.uk/",
                                DeviceRegistrationUrl: "https://www.ploom.co.uk/en/auth#/register",
                            },
                        },
                    ],
                },
            },
        },
    ],
};
export const ProxyConfigurationSchemaSchema = {
    allOf: [
        {
            type: "object",
            properties: {
                type: {
                    type: "string",
                    example: "configuration",
                },
                value: {
                    type: "object",
                    example: {
                        enabled: true,
                        services: [
                            {
                                name: "des-services/map/v1",
                                enabled: true,
                            },
                            {
                                name: "des-services/cgs/v1",
                                enabled: true,
                            },
                        ],
                    },
                },
            },
        },
    ],
};
export const ProxyTenantsSchemaSchema = {
    allOf: [
        {
            type: "object",
            properties: {
                type: {
                    type: "string",
                    example: "configuration",
                },
                value: {
                    type: "object",
                    example: {
                        "des-services/map/v1": [
                            {
                                tenant_token: "af0b721e3d4fe433c2229c26390e475cf8103fd9d70c05f9f2434e7",
                                tenant_code: "test-php",
                            },
                        ],
                        "des-services/cgs/v1": [
                            {
                                tenant_token: "a44fdef402635cc7e433c2229c26390e475cf8103fd9d70c05f",
                                tenant_code: "test-php",
                            },
                            {
                                tenant_token: "adb7002635dsac29c26390e475cf8103fd9d70c05f9f2434e771f8d58",
                                tenant_code: "test-qa",
                            },
                        ],
                    },
                },
            },
        },
    ],
};
export const ProxyServiceSchemaSchema = {
    allOf: [
        {
            type: "object",
            example: {
                "des-services/map/v1": {
                    ame: "des-services/map/v1",
                    enabled: true,
                    strategy: "service",
                    domain: "platform/configuration",
                    tenant_mapping: false,
                },
                "des-services/cgs/v1": {
                    name: "des-services/cgs/v1",
                    enabled: true,
                    strategy: "service",
                    domain: "cryptography",
                    tenant_mapping: false,
                },
            },
        },
    ],
};
export const TenantsProxySchemaSchema = {
    allOf: [
        {
            type: "object",
            properties: {
                service_key: {
                    type: "string",
                    example: "des-services_map_v1",
                },
                tenants: {
                    type: "array",
                    items: {
                        type: "object",
                        properties: {
                            tenant_token: {
                                type: "string",
                                example: "64fae1fc7dsadsadsa23baa54a5eca79971c8f400bab34e21c6afa4",
                            },
                            tenant_code: {
                                type: "string",
                                example: "test-qa",
                            },
                        },
                    },
                },
            },
        },
    ],
};
export const ProxyRedirectionsSchemaSchema = {
    allOf: [
        {
            type: "object",
            example: {
                "des-services/map/v1": {
                    configurations: "platform/configuration/public",
                },
                "des-services/cgs/v1": {
                    encrypt: "cryptography/encrypt",
                    decrypt: "cryptography/decrypt",
                },
            },
        },
    ],
};
export const PlatformVersionSchema = {
    allOf: [
        {
            type: "object",
            properties: {
                version: {
                    type: "string",
                    example: "v1.2.3",
                },
            },
        },
    ],
};
export const ActionVerificationItemSchema = {
    allOf: [
        {
            required: ["uuid", "channel", "identifier", "status"],
            type: "object",
            properties: {
                uuid: {
                    type: "string",
                    example: "603f027f-6c5d-4084-ad10-39ac6a3aa3b6",
                },
                channel: {
                    type: "string",
                    example: "email",
                },
                identifier: {
                    type: "string",
                    example: "test@example.pl",
                },
                name: {
                    type: "string",
                    nullable: true,
                    example: "John Doe",
                },
                status: {
                    type: "string",
                    example: "sent",
                },
            },
        },
    ],
};
export const AdapterSchema = {
    allOf: [
        {
            $ref: "#/components/schemas/AdapterFields",
        },
        {
            required: ["connections"],
            type: "object",
            properties: {
                connections: {
                    type: "array",
                    items: {
                        $ref: "#/components/schemas/AdapterConnectionFields",
                    },
                },
            },
        },
    ],
};
export const AdapterFieldsSchema = {
    required: ["name", "description", "code", "url", "options"],
    type: "object",
    properties: {
        type: {
            enum: ["age_verification", "payments", "orders"],
            type: "string",
            description: "Adapter type",
        },
        name: {
            type: "string",
            description: "Adapter name",
            example: "Test adapter",
        },
        description: {
            type: "string",
            description: "Adapter description",
            nullable: true,
            example: "Test adapter description",
        },
        code: {
            type: "string",
            description: "Adapter unique code",
            example: "test_adapter",
        },
        url: {
            type: "string",
            description: "Adapter base URL",
            example: "https://url.domain",
        },
        options: {
            type: "object",
            description: "Adapter additional options",
            nullable: true,
        },
    },
};
export const AdapterConnectionFieldsSchema = {
    required: ["token", "adapter_code", "tenant_code"],
    type: "object",
    properties: {
        token: {
            type: "string",
            description: "Adapter access token",
            example: "123456789",
        },
        adapter_code: {
            type: "string",
            description: "Adapter unique code",
            example: "test_adapter",
        },
        tenant_code: {
            type: "string",
            description: "Tenant unique code",
            example: "test_tenant",
        },
    },
};
export const AgeVerificationMethodFieldsSchema = {
    type: "object",
    properties: {
        adapter_code: {
            type: "string",
            description: "Verification adapter code",
            example: "veriff_async",
        },
        code: {
            type: "string",
            description: "Verification method code",
            example: "veriff_av",
        },
        type: {
            enum: ["sync", "async"],
            type: "string",
            description: "Verification method type",
            example: "sync",
        },
        name: {
            type: "string",
            description: "Verification method name",
            example: "Fake Passport",
        },
        description: {
            type: "string",
            description: "Verification method description",
            nullable: true,
            example: "Fake passport method",
        },
        fields: {
            type: "array",
            items: {
                type: "object",
                properties: {
                    code: {
                        type: "string",
                        description: "Verification method field code",
                        example: "passport_no",
                    },
                    label: {
                        type: "string",
                        description: "Verification method field label",
                        example: "Passport",
                    },
                    hint: {
                        type: "string",
                        description: "Hint for verification method field",
                        nullable: true,
                        example: "Only European passports",
                    },
                    validation: {
                        type: "string",
                        description: "Validation rules used for verification method field",
                        nullable: true,
                        example: "TBD",
                    },
                    type: {
                        enum: ["number", "string", "date", "bool", "array"],
                        type: "string",
                        description: "Verification type",
                        example: "string",
                    },
                    is_required: {
                        type: "boolean",
                        description: "Flag indicates whether this field is mandatory",
                        example: false,
                    },
                },
            },
            description: "Verification method fields content",
        },
    },
};
export const AgeVerificationItemHashSchemaSchema = {
    allOf: [
        {
            type: "object",
            properties: {
                data: {
                    $ref: "#/components/schemas/AgeVerificationItemHashFields",
                },
            },
        },
    ],
};
export const AgeVerificationItemFieldsSchema = {
    type: "object",
    properties: {
        uuid: {
            type: "string",
            description: "Age verification item uuid",
            example: "603f027f-6c5d-4084-ad10-39ac6a3aa3b6",
        },
        is_verified: {
            type: "boolean",
            description: "If age verification finished and successful",
            example: false,
        },
        verification_status: {
            type: "string",
            description: "Age verification status",
            example: "pending",
        },
        consumer_data: {
            type: "object",
            properties: {
                name: {
                    type: "string",
                    description: "Name",
                    nullable: true,
                },
                phone: {
                    type: "string",
                    description: "Phone number",
                    nullable: true,
                },
                date_of_birth: {
                    type: "string",
                    description: "Date of birth",
                    nullable: true,
                },
            },
            additionalProperties: {
                type: "string",
            },
            description: "Optional object with consumer data",
        },
        error: {
            type: "object",
            allOf: [
                {
                    $ref: "#/components/schemas/AgeVerificationErrorSchema",
                },
            ],
            nullable: true,
        },
    },
};
export const AgeVerificationItemHashFieldsSchema = {
    type: "object",
    properties: {
        age_verification_item_uuid: {
            type: "string",
            description: "AgeVerificationItemHash uuid",
            example: "603f027f-6c5d-4084-ad10-39ac6a3aa3b6",
        },
        consumer_uuid: {
            type: "string",
            description: "Consumer uuid",
            example: "603f027f-6c5d-4084-ad10-1234567890aa",
        },
    },
};
export const AgeVerificationErrorSchemaSchema = {
    required: ["code", "message"],
    type: "object",
    properties: {
        code: {
            type: "string",
            description: "Unique adapter error code",
            example: "age_verification::adapter_error.diia.age_not_eligible_error",
        },
        message: {
            type: "string",
            description: "Adapter error message",
            example: "Age is not eligible for positive verification.",
        },
        attributes: {
            type: "object",
            additionalProperties: {
                type: "string",
            },
            description: "Optional object with additional data",
            nullable: true,
            example: {
                age_limit: "21",
            },
        },
    },
};
export const AgeVerificationItemSchemaSchema = {
    allOf: [
        {
            type: "object",
            properties: {
                data: {
                    $ref: "#/components/schemas/AgeVerificationItemFields",
                },
            },
        },
    ],
};
export const CodeRouteFieldsSchema = {
    type: "object",
    properties: {
        code: {
            type: "string",
            description: "Unique string identifier",
            example: "ABC01",
        },
        name: {
            type: "string",
            description: "Internal name",
            example: "Test QR Code",
        },
        url: {
            type: "string",
            description: "URL associated with QR code",
            example: "https://fake-test-url.com/some-path",
        },
    },
};
export const CodeRouteSchema = {
    allOf: [
        {
            $ref: "#/components/schemas/CodeRouteFields",
        },
    ],
};
export const ExternalProviderSchema = {
    required: ["code", "name", "description"],
    type: "object",
    properties: {
        code: {
            type: "string",
            example: "7_eleven",
        },
        name: {
            type: "string",
            example: "7 Eleven",
        },
        description: {
            type: "string",
            example: "In-store coupon provider for the 7-Eleven chain",
        },
        fields: {
            type: "array",
            items: {
                $ref: "#/components/schemas/ExternalProviderField",
            },
            nullable: true,
        },
    },
};
export const ExternalProviderFieldSchema = {
    required: ["code", "label", "type", "is_required"],
    type: "object",
    properties: {
        code: {
            type: "string",
            example: "phone_number",
        },
        label: {
            type: "string",
            example: "Phone number",
        },
        hint: {
            type: "string",
            nullable: true,
            example: "Consumer phone number",
        },
        validation: {
            type: "string",
            nullable: true,
        },
        type: {
            enum: ["number", "string", "date", "bool", "array"],
            type: "string",
            example: "string",
        },
        is_required: {
            type: "boolean",
            example: true,
        },
    },
};
export const CryptographySchemaSchema = {
    allOf: [
        {
            type: "array",
            items: {
                type: "string",
                example: [
                    "eyJpdiI6Ind6c1dDSmhjZjBkVnpEM3giLCJ2YWx1ZSI6IllyUlJEazF0Y1pNUjBPM1Fjd1U2ejRmZTBBPT0iLCJtYWMiOiIiLCJ0YWciOiJHVTFmMkFuMzk3dFYwRTFRbm5xeStBPT0ifQ==",
                    "eyJpdiI6Ind6c1dDSmhjZjBkVnpEM3giLCJ2YWx1ZSI6IllyUlJEazF0Y1pNUjBPM1Fjd1U2ejRmZTBBPT0iLCJtYWMiOiIiLCJ0YWciOiJHVTFmMkFuMzk3dFYwRTFRbm5xeStBPT0ifQ==",
                ],
            },
        },
    ],
};
export const ImportCreateSchema = {
    allOf: [
        {
            $ref: "#/components/schemas/ImportCreateFields",
        },
    ],
};
export const ImportSchema = {
    allOf: [
        {
            $ref: "#/components/schemas/ImportFields",
        },
    ],
};
export const ImportFieldsSchema = {
    type: "object",
    properties: {
        id: {
            type: "string",
        },
        tenant_code: {
            type: "string",
        },
        status: {
            type: "string",
        },
        totalItems: {
            type: "integer",
        },
        importedItems: {
            type: "integer",
        },
        failedItems: {
            type: "integer",
        },
        created_at: {
            type: "string",
            description: "Record creation time",
            nullable: true,
            example: "2021-02-12T08:51:50Z",
        },
        updated_at: {
            type: "string",
            description: "Record update time",
            nullable: true,
            example: "2021-02-12T08:51:50Z",
        },
    },
};
export const ImportCreateFieldsSchema = {
    type: "object",
    properties: {
        tenantCode: {
            type: "string",
            description: "Import code",
            example: "ploom-cc",
        },
    },
};
export const ConsumerCanceledSchema = {
    type: "object",
    properties: {
        meta: {
            type: "object",
            properties: {
                event_type: {
                    type: "string",
                    description: "Webhook event type",
                    example: "consumer_canceled",
                },
                tenant_code: {
                    type: "string",
                    description: "Tenant code",
                    example: "test_tenant_it",
                },
            },
        },
        data: {
            type: "object",
            properties: {
                uuid: {
                    type: "string",
                    description: "Consumer uuid",
                },
                email: {
                    type: "string",
                    description: "Consumer email",
                },
            },
        },
    },
};
export const DISRegistrationSchemaSchema = {
    required: ["status", "createdAt"],
    type: "object",
    properties: {
        status: {
            type: "string",
            description: "Available statuses: registered, unregistered, consumer_attached",
            example: "registered",
        },
        createdAt: {
            type: "string",
            format: "date-time",
            example: "2024-07-23T12:20:05.0000000+00:00",
        },
        externalId: {
            type: "string",
            nullable: true,
            example: "354c12c7-ee9e-49d4-a7b2-c089b99b4f7a",
        },
        consumerId: {
            type: "string",
            nullable: true,
            example: "354c12c7-ee9e-49d4-a7b2-c089b99b4f7a",
        },
    },
};
export const DeviceIdSchema = {
    type: "object",
    properties: {
        deviceIdentifier: {
            type: "string",
            example: "1X232C68SXV4YDZ",
        },
    },
};
export const DISInventoryItemSchema = {
    type: "object",
    properties: {
        deviceId: {
            type: "string",
            nullable: true,
            example: "1X232C68SXV4YDZ",
        },
        deviceName: {
            type: "string",
            nullable: true,
            example: "Tobacco Sticks",
        },
        productId: {
            type: "string",
            nullable: true,
            example: "SN87223123BF",
        },
        registrationDate: {
            type: "string",
            format: "date-time",
            nullable: true,
            example: "2023-04-07T06:04:31.0000000+00:00",
        },
        warrantyExpiryDate: {
            type: "string",
            format: "date-time",
            nullable: true,
            example: "2024-04-06T12:00:00.0000000+00:00",
        },
        iotTenantCode: {
            type: "string",
            nullable: true,
            example: "",
        },
        productType: {
            type: "string",
            nullable: true,
            example: "04",
        },
        productColor: {
            type: "string",
            nullable: true,
            example: "102",
        },
        productVersion: {
            type: "string",
            nullable: true,
            example: "",
        },
        isVirtual: {
            type: "boolean",
            example: false,
        },
        isBluetooth: {
            type: "boolean",
            example: false,
        },
        userId: {
            type: "string",
            nullable: true,
            example: "354c12c7-ee9e-49d4-a7b2-c089b99b4f7a",
        },
        userAssignmentDate: {
            type: "string",
            format: "date-time",
            nullable: true,
            example: "2023-04-07T06:04:31.0000000+00:00",
        },
        tenantCode: {
            type: "string",
            nullable: true,
            example: "bd4cbb1c-19e4-4367-bacf-cc2b55ce340e",
        },
        countryCode: {
            type: "string",
            nullable: true,
            example: "UK",
        },
        trackingCode: {
            type: "string",
            nullable: true,
            example: "SN87223123BF",
        },
        randomCode: {
            type: "string",
            nullable: true,
            example: "1X232C68SXV4YDZ",
        },
        tenantCodeString: {
            type: "string",
            nullable: true,
            example: "ploom-uk",
        },
        externalId: {
            type: "string",
            nullable: true,
        },
        consumerId: {
            type: "string",
            nullable: true,
            example: "354c12c7-ee9e-49d4-a7b2-c089b99b4f7a",
        },
    },
};
export const UserDeviceDetailsSchema = {
    type: "object",
    properties: {
        is_allowed_to_register: {
            type: "boolean",
        },
        product_type: {
            type: "string",
            description: "device|sticks|accessory",
            example: "device",
        },
        registered_this_month: {
            type: "integer",
        },
        registered_this_week: {
            type: "integer",
        },
        remaining_weekly_limit: {
            type: "integer",
        },
        remaining_monthly_limit: {
            type: "integer",
        },
    },
};
export const WarrantySchema = {
    allOf: [
        {
            type: "object",
            properties: {
                status: {
                    type: "string",
                    example: "Ploom",
                },
                start_date: {
                    type: "string",
                    example: "2023-12-11 10:42:00",
                },
                expiration_date: {
                    type: "string",
                    example: "2023-12-11 10:42:00",
                },
                history_items: {
                    type: "array",
                    items: {
                        type: "object",
                        properties: {
                            action: {
                                type: "string",
                                example: "adjust_both",
                            },
                            reason: {
                                type: "string",
                                example: "Reason description",
                            },
                            data: {
                                type: "object",
                                properties: {
                                    before: {
                                        type: "object",
                                        properties: {
                                            status: {
                                                type: "string",
                                                example: "valid",
                                            },
                                            start_date: {
                                                type: "string",
                                                example: "2024-01-29 00:00:00",
                                            },
                                            expiration_date: {
                                                type: "string",
                                                example: "2024-01-29 00:00:00",
                                            },
                                        },
                                    },
                                    after: {
                                        type: "object",
                                        properties: {
                                            status: {
                                                type: "string",
                                                example: "valid",
                                            },
                                            start_date: {
                                                type: "string",
                                                example: "2024-01-29 00:00:00",
                                            },
                                            expiration_date: {
                                                type: "string",
                                                example: "2024-01-29 00:00:00",
                                            },
                                        },
                                    },
                                },
                            },
                        },
                    },
                },
            },
            nullable: true,
        },
    ],
};
export const UserInventorySchema = {
    type: "object",
    properties: {
        id: {
            type: "integer",
        },
        user_id: {
            type: "integer",
        },
        identifier_id: {
            type: "integer",
        },
        type: {
            type: "string",
        },
        product: {
            type: "string",
            default: "json_array()",
        },
        created_at: {
            type: "string",
            format: "date-time",
        },
        updated_at: {
            type: "string",
            format: "date-time",
        },
    },
};
export const IdentifierSchema = {
    type: "object",
    properties: {
        id: {
            type: "integer",
            nullable: true,
        },
        country_code: {
            type: "string",
            nullable: true,
        },
        tenant_code: {
            type: "string",
            nullable: true,
        },
        product_sku: {
            type: "string",
            nullable: true,
        },
        serial_code: {
            type: "string",
            nullable: true,
        },
        leaflet_code: {
            type: "string",
            nullable: true,
        },
        type: {
            type: "string",
        },
        is_used: {
            type: "boolean",
            default: "0",
        },
        is_virtual: {
            type: "boolean",
            default: "0",
        },
        created_at: {
            type: "string",
            format: "date-time",
        },
        updated_at: {
            type: "string",
            format: "date-time",
        },
    },
};
export const RegistrationHistorySchemaSchema = {
    allOf: [
        {
            type: "object",
            properties: {
                status: {
                    type: "string",
                    example: "registered",
                },
                created_at: {
                    type: "string",
                    example: "2024-02-14 13:29:06",
                },
                owner: {
                    type: "object",
                    allOf: [
                        {
                            $ref: "#/components/schemas/OwnerSchema",
                        },
                    ],
                    nullable: true,
                },
            },
        },
    ],
};
export const RegistrationSchemaSchema = {
    oneOf: [
        {
            $ref: "#/components/schemas/ConsumerFields",
        },
        {
            $ref: "#/components/schemas/ConsumerWithAuthenticationFields",
        },
    ],
};
export const InventoryItemSchemaSchema = {
    allOf: [
        {
            type: "object",
            properties: {
                tenant_code: {
                    type: "string",
                    nullable: true,
                    example: "test-php",
                },
                country_code: {
                    type: "string",
                    nullable: true,
                    example: "CC",
                },
                spex_cluster_name: {
                    type: "string",
                    nullable: true,
                },
                product_sku: {
                    type: "string",
                    nullable: true,
                    example: "0000508",
                },
                serial_code: {
                    type: "string",
                    nullable: true,
                    example: "SN00000000PM",
                },
                leaflet_code: {
                    type: "string",
                    nullable: true,
                    example: "002536M000000000",
                },
                user_code: {
                    type: "string",
                    nullable: true,
                    example: "AB123450GENX678",
                },
                type: {
                    type: "string",
                    nullable: true,
                    example: "imported",
                },
                is_used: {
                    type: "boolean",
                    nullable: true,
                    example: true,
                },
                is_virtual: {
                    type: "boolean",
                    nullable: true,
                    example: true,
                },
                is_registrable: {
                    type: "boolean",
                    nullable: true,
                    example: true,
                },
                warranty: {
                    type: "object",
                    allOf: [
                        {
                            $ref: "#/components/schemas/Warranty",
                        },
                    ],
                    nullable: true,
                },
                current_registration: {
                    type: "object",
                    allOf: [
                        {
                            $ref: "#/components/schemas/RegistrationSchema",
                        },
                    ],
                    nullable: true,
                },
                current_owner: {
                    type: "object",
                    allOf: [
                        {
                            $ref: "#/components/schemas/OwnerSchema",
                        },
                    ],
                    nullable: true,
                },
                registration_history: {
                    type: "array",
                    items: {
                        $ref: "#/components/schemas/RegistrationHistorySchema",
                    },
                    nullable: true,
                },
            },
        },
    ],
};
export const InventoryItemValidationSchemaSchema = {
    allOf: [
        {
            type: "object",
            properties: {
                serial_code: {
                    type: "string",
                    nullable: true,
                    example: "SN00000000PM",
                },
                leaflet_code: {
                    type: "string",
                    nullable: true,
                    example: "002536M000000000",
                },
            },
        },
    ],
};
export const OwnerSchemaSchema = {
    allOf: [
        {
            type: "object",
            properties: {
                des_user_id: {
                    type: "string",
                    description: "Registered customer UUID",
                    nullable: true,
                    example: "e3ff9b53-9096-40c9-8b4c-089f81f0898e",
                },
                external_user_id: {
                    type: "string",
                    description: "Registered external user ID/UUID (Ambassador / Lead)",
                    nullable: true,
                    example: "e3ff9b53-9096-40c9-8b4c-089f81f0898e",
                },
                personal_identifier: {
                    type: "string",
                    description: "Alternative to provide personal identifier like email for not registered users",
                    nullable: true,
                    example: "e3ff9b53-9096-40c9-8b4c-089f81f0898e",
                },
            },
            nullable: true,
        },
    ],
};
export const ProductPrefixSchema = {
    allOf: [
        {
            $ref: "#/components/schemas/ProductPrefixFields",
        },
        {
            $ref: "#/components/schemas/CommonFields",
        },
    ],
};
export const ProductPrefixRequestFieldsSchema = {
    required: ["prefix", "sku", "tenant_code"],
    type: "object",
    properties: {
        product_color: {
            type: "string",
            description: "Product Color",
            nullable: true,
            example: "03",
        },
        product_type: {
            type: "string",
            description: "Product Type",
            nullable: true,
            example: "04",
        },
        prefix: {
            type: "string",
            description: "Product Prefix",
            example: "X239",
        },
        sku: {
            type: "string",
            description: "Product Prefix SKU",
            example: "portable_stick_tray",
        },
        tenant_code: {
            type: "string",
            description: "Product Prefix Tenant Code",
            example: "ploom-uk",
        },
    },
};
export const ProductPrefixFieldsSchema = {
    type: "object",
    properties: {
        product_color: {
            type: "string",
            description: "Product Color",
            nullable: true,
            example: "03",
        },
        product_type: {
            type: "string",
            description: "Product Type",
            nullable: true,
            example: "04",
        },
        notes: {
            type: "string",
            description: "Product Notes",
            nullable: true,
        },
        prefix: {
            type: "string",
            description: "Product Prefix",
            nullable: true,
            example: "X239",
        },
        sku: {
            type: "string",
            description: "Product Prefix SKU",
            nullable: true,
            example: "portable_stick_tray",
        },
        tenant_code: {
            type: "string",
            description: "Product Prefix Tenant Code",
            example: "ploom-uk",
        },
    },
};
export const InventoryImportErrorReportSchemaSchema = {
    allOf: [
        {
            type: "object",
            properties: {
                id: {
                    type: "integer",
                    example: 1,
                },
                report_id: {
                    type: "integer",
                    example: 1,
                },
                message: {
                    type: "string",
                    example: "Error message",
                },
                data: {
                    type: "object",
                    properties: {
                        sku: {
                            type: "string",
                            example: "0000601",
                        },
                        serial: {
                            type: "string",
                            example: "PLP5RN9K0",
                        },
                    },
                    description: "JSON data of the error",
                },
                type: {
                    type: "string",
                    example: "warning",
                },
                created_at: {
                    type: "string",
                    example: "2024-02-14 13:29:06",
                },
            },
        },
    ],
};
export const OwnerReportSchemaSchema = {
    allOf: [
        {
            type: "object",
            properties: {
                des_user_id: {
                    type: "string",
                    description: "Registered CAS customer UUID",
                    nullable: true,
                    example: "e3ff9b53-9096-40c9-8b4c-089f81f0898e",
                },
                external_user_id: {
                    type: "string",
                    description: "Registered external customer ID/UUID (Ambassador)",
                    nullable: true,
                    example: "e3ff9b53-9096-40c9-8b4c-089f81f0898e",
                },
                personal_identifier: {
                    type: "string",
                    description: "Alternative to provide personal identifier like email for not registered users",
                    nullable: true,
                    example: "john@email.com",
                },
            },
            nullable: true,
        },
    ],
};
export const RegistrationReportSchemaSchema = {
    allOf: [
        {
            type: "object",
            properties: {
                status: {
                    type: "string",
                    nullable: true,
                    example: "registered",
                },
                registration_date: {
                    type: "string",
                    nullable: true,
                    example: "2024-02-14 13:29:06",
                },
            },
            nullable: true,
        },
    ],
};
export const ProductReportSchemaSchema = {
    allOf: [
        {
            type: "object",
            properties: {
                external_id: {
                    type: "integer",
                    nullable: true,
                    example: 10120301,
                },
                brand: {
                    type: "string",
                    nullable: true,
                    example: "Ploom",
                },
                sku: {
                    type: "string",
                    example: "evo-mix-10-pack",
                },
                type: {
                    type: "string",
                    nullable: true,
                    example: "device",
                },
                name: {
                    type: "string",
                    nullable: true,
                    example: "EVO Mix-and-Match 10 Pack",
                },
                loyalty_rule: {
                    type: "string",
                    nullable: true,
                    example: "device_registered",
                },
            },
            nullable: true,
        },
    ],
};
export const InventoryImportReportSchemaSchema = {
    allOf: [
        {
            type: "object",
            properties: {
                original_path: {
                    type: "string",
                    nullable: true,
                    example: "file.csv",
                },
                archived_path: {
                    type: "string",
                    nullable: true,
                    example: "2024-02-14 13:29:06 file.csv",
                },
                errors_number: {
                    type: "integer",
                    nullable: true,
                    example: 1,
                },
                successes_number: {
                    type: "integer",
                    nullable: true,
                    example: 2,
                },
                total_number: {
                    type: "integer",
                    nullable: true,
                    example: 3,
                },
                started_at: {
                    type: "string",
                    nullable: true,
                    example: "2024-02-14 13:29:06",
                },
                finished_at: {
                    type: "string",
                    nullable: true,
                    example: "2024-02-14 13:29:06",
                },
            },
        },
    ],
};
export const PrefixReportSchemaSchema = {
    allOf: [
        {
            type: "object",
            properties: {
                prefix: {
                    type: "string",
                    nullable: true,
                    example: "X242",
                },
                tenant_code: {
                    type: "string",
                    nullable: true,
                    example: "ploom-cz",
                },
                country_code: {
                    type: "string",
                    nullable: true,
                    example: "CZ",
                },
                spex_cluster: {
                    type: "string",
                    nullable: true,
                },
                product_color: {
                    type: "string",
                    nullable: true,
                    example: "04",
                },
                product_type: {
                    type: "string",
                    nullable: true,
                    example: "05",
                },
                product: {
                    type: "object",
                    allOf: [
                        {
                            $ref: "#/components/schemas/ProductReportSchema",
                        },
                    ],
                    nullable: true,
                },
            },
        },
    ],
};
export const InventoryItemReportSchemaSchema = {
    allOf: [
        {
            type: "object",
            properties: {
                tenant_code: {
                    type: "string",
                    nullable: true,
                    example: "test-php",
                },
                country_code: {
                    type: "string",
                    nullable: true,
                    example: "CC",
                },
                spex_cluster_name: {
                    type: "string",
                    nullable: true,
                },
                product_sku: {
                    type: "string",
                    nullable: true,
                    example: "0000508",
                },
                serial_code: {
                    type: "string",
                    nullable: true,
                    example: "SN00000000PM",
                },
                leaflet_code: {
                    type: "string",
                    nullable: true,
                    example: "002536M000000000",
                },
                created_at: {
                    type: "string",
                    nullable: true,
                    example: "2024-02-14 13:29:06",
                },
                updated_at: {
                    type: "string",
                    nullable: true,
                    example: "2024-02-14 13:29:06",
                },
                is_used: {
                    type: "boolean",
                    nullable: true,
                    example: true,
                },
                is_virtual: {
                    type: "boolean",
                    nullable: true,
                    example: true,
                },
                warranty: {
                    type: "object",
                    allOf: [
                        {
                            $ref: "#/components/schemas/Warranty",
                        },
                    ],
                    nullable: true,
                },
                product: {
                    type: "object",
                    allOf: [
                        {
                            $ref: "#/components/schemas/ProductReportSchema",
                        },
                    ],
                    nullable: true,
                },
                current_registration: {
                    type: "object",
                    allOf: [
                        {
                            $ref: "#/components/schemas/RegistrationReportSchema",
                        },
                    ],
                    nullable: true,
                },
                current_owner: {
                    type: "object",
                    allOf: [
                        {
                            $ref: "#/components/schemas/OwnerReportSchema",
                        },
                    ],
                    nullable: true,
                },
                registration_history: {
                    type: "array",
                    items: {
                        $ref: "#/components/schemas/RegistrationReportSchema",
                    },
                    nullable: true,
                },
            },
        },
    ],
};
export const SpexClusterFieldsSchema = {
    required: ["name", "country_codes"],
    type: "object",
    properties: {
        name: {
            type: "string",
            description: "The name of the Spex Cluster",
            example: "SPEX1",
        },
        country_codes: {
            type: "array",
            items: {
                type: "string",
            },
            description: "The country codes of the Spex Cluster",
            example: ["US", "CA"],
        },
        created_at: {
            type: "string",
            nullable: true,
            example: "2021-01-01 00:00:00",
        },
        updated_at: {
            type: "string",
            nullable: true,
            example: "2021-01-01 00:00:00",
        },
    },
};
export const SpexClusterSchema = {
    allOf: [
        {
            $ref: "#/components/schemas/SpexClusterFields",
        },
    ],
};
export const PurchaseSchemaSchema = {
    allOf: [
        {
            required: ["uuid", "external_created_at", "type", "items"],
            type: "object",
            properties: {
                uuid: {
                    type: "string",
                    description: "Action uuid",
                    example: "603f027f-6c5d-4084-ad10-39ac6a3aa3b6",
                },
                external_created_at: {
                    type: "string",
                    description: "External created at",
                    example: "2024-07-31 13:45:59",
                },
                type: {
                    type: "string",
                    description: "Type",
                    example: "device_purchase",
                },
                items: {
                    type: "array",
                    items: {
                        required: ["sku", "quantity"],
                        type: "object",
                        properties: {
                            sku: {
                                type: "string",
                                description: "SKU of purchase item",
                            },
                            quantity: {
                                type: "number",
                                description: "Quantity of purchase items",
                            },
                        },
                    },
                    description: "Purchase items",
                },
            },
        },
    ],
};
export const ActionSchemaSchema = {
    allOf: [
        {
            required: ["uuid", "external_created_at", "status", "email", "type"],
            type: "object",
            properties: {
                uuid: {
                    type: "string",
                    description: "Action uuid",
                    example: "603f027f-6c5d-4084-ad10-39ac6a3aa3b6",
                },
                external_created_at: {
                    type: "string",
                    description: "External created at",
                    example: "2024-07-31 13:45:59",
                },
                status: {
                    enum: ["new", "waiting-reward-rules", "processing", "processed", "failed"],
                    type: "string",
                    description: "Status",
                    example: "new",
                },
                email: {
                    type: "string",
                    description: "Lead email address",
                    example: "john.doe@example.com",
                },
                b2c_rule_code: {
                    type: "string",
                    description: "B2C rule code",
                    nullable: true,
                },
                type: {
                    type: "string",
                    description: "Type",
                    example: "device_purchase",
                },
                data: {
                    type: "object",
                    description: "Data details",
                },
                tracking: {
                    type: "object",
                    allOf: [
                        {
                            $ref: "#/components/schemas/TrackingSchema",
                        },
                    ],
                    nullable: true,
                },
            },
        },
    ],
};
export const ActionSourceSchemaSchema = {
    allOf: [
        {
            required: ["representative_id", "source_id", "source_type"],
            type: "object",
            properties: {
                representative_id: {
                    type: "string",
                    description: "Representative id",
                    example: "11",
                },
                source_id: {
                    type: "string",
                    description: "Source id",
                    example: "1234",
                },
                source_type: {
                    type: "string",
                    description: "Source type",
                    example: "connexus",
                },
            },
        },
    ],
};
export const LeadSchemaSchema = {
    allOf: [
        {
            required: ["email", "is_age_verified", "is_converted", "last_name", "uuid"],
            type: "object",
            properties: {
                address: {
                    type: "object",
                    allOf: [
                        {
                            $ref: "#/components/schemas/LeadAddressSchema",
                        },
                    ],
                    nullable: true,
                },
                brand: {
                    type: "string",
                    description: "Brand",
                    nullable: true,
                    example: "Ploom",
                },
                date_of_birth: {
                    type: "string",
                    description: "Date of birth",
                    nullable: true,
                    example: "1990-01-02",
                },
                email: {
                    type: "string",
                    description: "Email address",
                    example: "john.doe@example.com",
                },
                extra_profile_information: {
                    type: "object",
                    properties: {
                        language: {
                            type: "string",
                            description: "Language",
                            example: "en",
                        },
                    },
                    nullable: true,
                },
                first_name: {
                    type: "string",
                    description: "First name",
                    nullable: true,
                    example: "John",
                },
                gender: {
                    enum: ["male", "female", "prefer_not_to_say", null],
                    type: "string",
                    description: "Gender",
                    nullable: true,
                    example: "male",
                },
                is_age_verified: {
                    type: "boolean",
                    description: "Is age verified",
                    example: true,
                },
                is_converted: {
                    type: "boolean",
                    description: "Is converted",
                    example: false,
                },
                last_name: {
                    type: "string",
                    description: "Last name",
                    example: "Doe",
                },
                notification_channel: {
                    enum: ["email", "sms", null],
                    type: "string",
                    description: "Notification channel",
                    nullable: true,
                    example: "email",
                },
                phone: {
                    type: "string",
                    description: "Phone number",
                    nullable: true,
                    example: "+48123456789",
                },
                source: {
                    type: "object",
                    allOf: [
                        {
                            $ref: "#/components/schemas/LeadSourceSchema",
                        },
                    ],
                    nullable: true,
                },
                tracking: {
                    type: "object",
                    allOf: [
                        {
                            $ref: "#/components/schemas/TrackingSchema",
                        },
                    ],
                    nullable: true,
                },
                uuid: {
                    type: "string",
                    description: "Lead uuid",
                    example: "603f027f-6c5d-4084-ad10-39ac6a3aa3b6",
                },
            },
        },
    ],
};
export const LeadSourceSchemaSchema = {
    allOf: [
        {
            required: ["representative_id", "source_id", "source_type"],
            type: "object",
            properties: {
                channel: {
                    type: "string",
                    description: "Channel",
                    nullable: true,
                    example: "offline",
                },
                representative_id: {
                    type: "string",
                    description: "Representative id",
                    example: "11",
                },
                source_id: {
                    type: "string",
                    description: "Source id",
                    example: "1234",
                },
                source_type: {
                    type: "string",
                    description: "Source type",
                    example: "connexus",
                },
            },
        },
    ],
};
export const LeadAddressSchemaSchema = {
    allOf: [
        {
            type: "object",
            properties: {
                administrative_area_level_2: {
                    type: "string",
                    description: "Second-order civil entity below the country level",
                    nullable: true,
                    example: "Poblacion",
                },
                city: {
                    type: "string",
                    description: "City",
                    nullable: true,
                    example: "Warsaw",
                },
                postcode: {
                    type: "string",
                    description: "Postal code",
                    nullable: true,
                    example: "01-234",
                },
                region: {
                    type: "string",
                    description: "Region",
                    nullable: true,
                    example: "Poland",
                },
                street: {
                    type: "array",
                    items: {
                        type: "string",
                        nullable: true,
                    },
                    description: "Street and numbers",
                    nullable: true,
                    example: ["12", "Main St"],
                },
                sublocality_level_2: {
                    type: "string",
                    description: "Second-order civil entity below a locality",
                    nullable: true,
                    example: "Isabela",
                },
                neighborhood: {
                    type: "string",
                    description: "Neighborhood/Area",
                    nullable: true,
                    example: "Al Safa",
                },
                premise: {
                    type: "string",
                    description: "Building name",
                    nullable: true,
                    example: "Safa Heights, 12",
                },
                landmark: {
                    type: "string",
                    description: "Landmark & special instructions",
                    nullable: true,
                    example: "Near Dubai Water Canal, opposite Safa Park",
                },
                district: {
                    type: "string",
                    description: "District",
                    nullable: true,
                    example: "Dubai",
                },
                building_number: {
                    type: "string",
                    description: "Building number",
                    nullable: true,
                    example: "456B",
                },
            },
        },
    ],
};
export const LoyaltyDomainConfigurationSchema = {
    required: ["is_active"],
    type: "object",
    properties: {
        is_active: {
            type: "boolean",
            description: "Is Loyalty active",
            example: false,
        },
    },
};
export const validity_rulesSchema = {
    required: ["time"],
    type: "object",
    properties: {
        time: {
            required: ["limited", "from", "to"],
            type: "object",
            properties: {
                limited: {
                    type: "boolean",
                    description: "Is limited",
                    nullable: true,
                    example: true,
                },
                from: {
                    type: "string",
                    description: "From",
                    nullable: true,
                    example: "2023-09-12T11:18:47Z",
                },
                to: {
                    type: "string",
                    description: "To",
                    nullable: true,
                    example: "2023-09-12T11:18:47Z",
                },
            },
        },
    },
    nullable: true,
};
export const IndexEarningResponseSchemaSchema = {
    allOf: [
        {
            required: [
                "identifier",
                "type",
                "levels",
                "points_with_multiply",
                "points_without_multiply",
                "is_available",
                "is_read",
                "validity_rules",
            ],
            type: "object",
            properties: {
                identifier: {
                    type: "string",
                    description: "Reward identifier",
                    example: "b0cd9098-xxxx-43d5-b72c-00000000",
                },
                type: {
                    enum: ["article", "product"],
                    type: "string",
                    description: "Earning type",
                    example: "prize",
                },
                levels: {
                    type: "array",
                    items: {
                        type: "string",
                        example: "Gold",
                    },
                    description: "Tier levels",
                },
                points_with_multiply: {
                    type: "number",
                    description: "Amount of points with multiply",
                    example: 12.34,
                },
                points_without_multiply: {
                    type: "number",
                    description: "Amount of points without multiply",
                    example: 10,
                },
                is_available: {
                    type: "boolean",
                    description: "Is available",
                    example: true,
                },
                is_read: {
                    type: "boolean",
                    description: "Is read",
                    nullable: true,
                    example: true,
                },
                validity_rules: {
                    $ref: "#/components/schemas/validity_rules",
                },
            },
        },
    ],
};
export const EventRequestBodySchemaSchema = {
    allOf: [
        {
            required: ["event_type"],
            type: "object",
            properties: {
                event_type: {
                    type: "string",
                    description: "Event type",
                    example: "welcome",
                },
                multiplier: {
                    type: "integer",
                    description: "Number of times event has to be triggered",
                    nullable: true,
                    example: 1,
                },
            },
        },
    ],
};
export const TransferRequestBodySchemaSchema = {
    allOf: [
        {
            required: ["points"],
            type: "object",
            properties: {
                points: {
                    type: "integer",
                    example: 70,
                },
                comment: {
                    type: "string",
                    nullable: true,
                    example: "Comment",
                },
                wallet_code: {
                    type: "string",
                    nullable: true,
                    example: "tiers points",
                },
            },
        },
    ],
};
export const SurveyRequestBodySchemaSchema = {
    allOf: [
        {
            required: ["survey_id"],
            type: "object",
            properties: {
                survey_id: {
                    type: "string",
                    description: "Survey ID",
                    example: "survey1",
                },
            },
        },
    ],
};
export const IndexRewardResponseSchemaSchema = {
    allOf: [
        {
            required: [
                "identifier",
                "type",
                "brand_name",
                "presentation",
                "points",
                "price",
                "has_coupons",
                "levels",
                "created_at",
                "validity_rules",
                "custom_attributes",
            ],
            type: "object",
            properties: {
                identifier: {
                    type: "string",
                    description: "Reward identifier",
                    example: "b0cd9098-xxxx-43d5-b72c-00000000",
                },
                type: {
                    enum: ["campaign", "prize", "external"],
                    type: "string",
                    description: "Reward type",
                    example: "prize",
                },
                brand_name: {
                    type: "string",
                    description: "Brand name",
                    example: "ploom",
                },
                presentation: {
                    required: ["name", "images"],
                    type: "object",
                    properties: {
                        name: {
                            type: "string",
                            description: "Name",
                            example: "20$ for 20 points",
                        },
                        description: {
                            type: "string",
                            description: "Description",
                            nullable: true,
                            example: "Reward for reading article [Silver]",
                        },
                        images: {
                            type: "array",
                            items: {
                                type: "string",
                                description: "Image url",
                            },
                            description: "Images",
                        },
                    },
                },
                points: {
                    type: "number",
                    description: "Points amount",
                    example: 12.34,
                },
                price: {
                    type: "number",
                    description: "Price",
                    example: 12.34,
                },
                has_coupons: {
                    type: "boolean",
                    description: "Has coupons",
                    example: true,
                },
                levels: {
                    type: "array",
                    items: {
                        type: "string",
                        example: "Gold",
                    },
                    description: "Tier levels",
                },
                created_at: {
                    type: "string",
                    description: "Created at",
                    example: "2023-09-12T11:18:47Z",
                },
                custom_attributes: {
                    required: ["color", "locations"],
                    type: "object",
                    properties: {
                        color: {
                            type: "string",
                            description: "Color name",
                            nullable: true,
                            example: "blue",
                        },
                        locations: {
                            type: "array",
                            items: {
                                type: "string",
                                example: "Berlin",
                            },
                            description: "Locations",
                        },
                    },
                },
                validity_rules: {
                    $ref: "#/components/schemas/validity_rules",
                },
            },
        },
    ],
};
export const RewardResponseSchemaSchema = {
    allOf: [
        {
            required: ["name", "reward_uuid", "points", "price"],
            type: "object",
            properties: {
                name: {
                    type: "string",
                    example: "16 Eur",
                },
                reward_uuid: {
                    type: "string",
                    example: "b0cd9098-xxxx-43d5-b72c-00000000",
                },
                points: {
                    type: "integer",
                    example: 60,
                },
                price: {
                    type: "integer",
                    example: 16,
                },
            },
        },
    ],
};
export const EligibleRewardResponseSchemaSchema = {
    allOf: [
        {
            required: ["reward_uuid", "points", "price", "is_eligible", "skus"],
            type: "object",
            properties: {
                reward_uuid: {
                    type: "string",
                    example: "b0cd9098-xxxx-43d5-b72c-00000000",
                },
                points: {
                    type: "integer",
                    example: 60,
                },
                price: {
                    type: "integer",
                    example: 16,
                },
                is_eligible: {
                    type: "boolean",
                    example: true,
                },
                skus: {
                    type: "array",
                    items: {
                        type: "string",
                    },
                    example: ["sku-1", "sku-2"],
                },
            },
        },
    ],
};
export const RedeemRewardResponseSchemaSchema = {
    allOf: [
        {
            required: ["uuid", "code"],
            type: "object",
            properties: {
                uuid: {
                    type: "string",
                    description: "Issued reward UUID",
                    example: "b0cd9098-xxxx-43d5-b72c-00000000",
                },
                code: {
                    type: "string",
                    description: "Issued coupon code",
                    example: "coupon-code",
                },
            },
        },
    ],
};
export const EligibleRewardRequestBodySchemaSchema = {
    allOf: [
        {
            required: ["order"],
            type: "object",
            properties: {
                order: {
                    required: ["order_total", "items"],
                    type: "object",
                    properties: {
                        order_total: {
                            type: "number",
                            description: "Total price",
                            example: 100,
                        },
                        minimum_payable_amount: {
                            type: "integer",
                            description: "Minimum amount that a customer has to pay",
                            example: 10,
                        },
                        items: {
                            type: "object",
                            properties: {
                                "sku-1": {
                                    required: ["price", "qty"],
                                    type: "object",
                                    properties: {
                                        price: {
                                            type: "integer",
                                            example: 10,
                                        },
                                        qty: {
                                            type: "integer",
                                            description: "Quantity",
                                            example: 2,
                                        },
                                        categories: {
                                            type: "array",
                                            items: {
                                                type: "integer",
                                            },
                                            description: "List of categories which this product belongs to",
                                            example: [125, 255],
                                        },
                                    },
                                },
                                "sku-2": {
                                    required: ["price", "qty"],
                                    type: "object",
                                    properties: {
                                        price: {
                                            type: "integer",
                                            example: 10,
                                        },
                                        qty: {
                                            type: "integer",
                                            description: "Quantity",
                                            example: 2,
                                        },
                                        categories: {
                                            type: "array",
                                            items: {
                                                type: "integer",
                                            },
                                            description: "List of categories which this product belongs to",
                                            example: [125, 255],
                                        },
                                    },
                                },
                            },
                        },
                    },
                },
            },
        },
    ],
};
export const TierResponseSchemaSchema = {
    allOf: [
        {
            required: ["name", "condition_value"],
            type: "object",
            properties: {
                name: {
                    type: "string",
                    example: "Gold",
                },
                condition_value: {
                    type: "integer",
                    description: "Points amount to achieve this tier",
                    example: 200,
                },
            },
        },
    ],
};
export const TemplateVariableFieldsSchema = {
    type: "object",
    properties: {
        name: {
            type: "string",
            description: "Variable name",
            example: "first_name",
        },
        required: {
            type: "boolean",
            description: "Is the variable required?",
            nullable: true,
        },
        alias: {
            type: "string",
            description: "To rename the variable in final payload",
            nullable: true,
            example: "u_first_name",
        },
        validation: {
            type: "string",
            description: "To validate the variable via some Laravel validator",
            nullable: true,
            example: "string",
        },
    },
};
export const TemplateFieldsSchema = {
    type: "object",
    properties: {
        id: {
            type: "integer",
            description: "Template primary key",
            example: 231,
        },
        provider: {
            enum: [
                "PIPEDREAM",
                "HTTP_SENDER",
                "CM",
                "SENDGRID",
                "ADOBE_CAMPAIGN",
                "ADOBE_CAMPAIGN_SMS",
                "KAKAO_TALK",
                "TWILIO",
            ],
            type: "string",
            description: "Provider code",
            example: "ADOBE_CAMPAIGN",
        },
        type: {
            type: "string",
            description: "Template type code",
            example: "ABANDONED_CART",
        },
        options: {
            $ref: "#/components/schemas/TemplateOptionFields",
        },
        variables: {
            type: "array",
            items: {
                $ref: "#/components/schemas/TemplateVariable",
            },
            description: "Template variables",
        },
    },
};
export const TemplateSchema = {
    allOf: [
        {
            $ref: "#/components/schemas/TemplateFields",
        },
    ],
};
export const TemplateOptionFieldsSchema = {
    type: "object",
    properties: {
        with_email_in_payload: {
            type: "boolean",
            description: "Should be email added automatically to the final message?",
            nullable: true,
        },
        with_body_summary: {
            type: "boolean",
            description: "Should a body field be generated with the HTML summary of all payload fields, delimited by break tags?",
            nullable: true,
        },
        headers: {
            type: "object",
            description: "Customer headers to pass to final provider",
            nullable: true,
            example: {
                "X-Header-1": "Value 1",
                "X-Header-2": "Value 2",
            },
        },
        without_datetime: {
            type: "boolean",
            description: "Exclude datetime field automatically added to all SENDGRID messages",
            nullable: true,
        },
        with_multi_lang: {
            type: "boolean",
            description: "Should be iso_code field added to the message based on incoming header or Consumer preferred language?",
            nullable: true,
        },
        with_tenant_code: {
            type: "boolean",
            description: "Should be omp_tenant_code added to the message? (Boolean or string with final field name)",
            nullable: true,
        },
        with_ctx_wrap: {
            type: "boolean",
            description: "Should be whole final payload wrapped in ctx field?",
            nullable: true,
        },
        with_promo_code: {
            type: "string",
            description: 'bool or string with final field name, is bool "promo_code" will be used',
            nullable: true,
        },
        multilang_templates: {
            type: "object",
            description: "Mapping of multilanguage templates for SENDGRID especially",
            nullable: true,
            example: {
                en: "d-12311214124",
                de: "d-55224234234",
            },
        },
        consent_check: {
            type: "string",
            description: "Use consent/purpose ID for Marketing Consent check before sending the message",
            nullable: true,
            example: "ui562-asdg-aasdfa-234-23424",
        },
    },
};
export const TemplateVariableSchema = {
    allOf: [
        {
            $ref: "#/components/schemas/TemplateVariableFields",
        },
    ],
};
export const MarketingCommunicationSchema = {
    allOf: [
        {
            $ref: "#/components/schemas/MarketingCommunicationBaseFields",
        },
    ],
};
export const MarketingCommunicationInputFieldsSchema = {
    required: ["email", "category"],
    type: "object",
    properties: {
        email: {
            type: "string",
            description: "Marketing communication email",
            example: "test@example.com",
        },
        category: {
            type: "string",
            description: "Marketing communication category",
            example: "marketing",
        },
        consents: {
            type: "array",
            items: {
                $ref: "#/components/schemas/ConsentFields",
            },
        },
        preferredLanguage: {
            type: "string",
            description: "Marketing communication preferred language",
            example: "en",
        },
    },
};
export const EmailFieldsSchema = {
    required: ["email"],
    type: "object",
    properties: {
        email: {
            type: "string",
            description: "Email",
            example: "test-v2@example.com",
        },
    },
};
export const ConsentFieldsSchema = {
    required: ["id", "accepted"],
    type: "object",
    properties: {
        id: {
            type: "string",
            description: "Consent uuid",
            example: "d20c5d24-2c77-437c-b4c2-b39ee6eee9b3",
        },
        accepted: {
            type: "boolean",
            description: "Consent accepted or not",
            example: true,
        },
    },
};
export const PreferredLanguageFieldsSchema = {
    required: ["preferredLanguage"],
    type: "object",
    properties: {
        preferredLanguage: {
            type: "string",
            description: "Preferred language code",
            example: "en",
        },
    },
};
export const MarketingCommunicationBaseFieldsSchema = {
    required: ["uuid", "subscriber_uuid", "email", "category"],
    type: "object",
    properties: {
        uuid: {
            type: "string",
            description: "Marketing communication uuid",
            example: "603f027f-6c5d-4084-ad10-39ac6a3aa3b6",
        },
        subscriber_uuid: {
            type: "string",
            description: "Marketing communication uuid",
            example: "603f027f-6c5d-4084-ad10-39ac6a3aa3b6",
        },
        email: {
            type: "string",
            description: "Marketing communication email",
            example: "test@example.com",
        },
        category: {
            type: "string",
            description: "Marketing communication category",
            example: "marketing",
        },
    },
};
export const MarketingCommunicationInputSchema = {
    allOf: [
        {
            $ref: "#/components/schemas/MarketingCommunicationInputFields",
        },
    ],
};
export const ActivityLogFieldsSchema = {
    type: "object",
    properties: {
        log_name: {
            type: "string",
            description: "Log name",
            example: "default",
        },
        description: {
            type: "string",
            description: "Event description",
            example: "updated",
        },
        subject_type: {
            type: "string",
            description: "Class of related model",
            nullable: true,
            example: "Models\\Country",
        },
        subject_id: {
            type: "integer",
            description: "Id of related model",
            nullable: true,
            example: "1",
        },
        event: {
            type: "string",
            description: "",
            nullable: true,
            example: "updated",
        },
        causer_name: {
            type: "string",
            description: "Changes causer name",
            nullable: true,
            example: "John Doe",
        },
        causer_email: {
            type: "string",
            description: "Changes causer email",
            nullable: true,
            example: "john@example.com",
        },
        tenant_code: {
            type: "string",
            description: "Related tenant code",
            nullable: true,
            example: "tenant-code",
        },
        properties: {
            type: "object",
            description: "Properties of activity",
            example: '{"old": {"name": "Afganistan", "iso_code": "AF"}, "attributes": {"name": "Afghanistan", "iso_code": "AF"}}',
        },
        batch_uuid: {
            type: "string",
            description: "",
            nullable: true,
            example: "Batch uuid",
        },
        id: {
            type: "integer",
            description: "Record identifier",
            format: "int64",
            example: 1,
        },
        created_at: {
            type: "string",
            description: "Record creation time",
            example: "2024-02-26 08:28:06",
        },
        updated_at: {
            type: "string",
            description: "Record update time",
            example: "2024-02-26 08:28:06",
        },
    },
};
export const ActivityLogSchema = {
    allOf: [
        {
            $ref: "#/components/schemas/ActivityLogFields",
        },
    ],
};
export const HealthCheckSchema = {
    required: ["status", "checks"],
    type: "object",
    properties: {
        status: {
            enum: ["failed", "ok"],
            type: "string",
            example: "failed",
        },
        level: {
            enum: ["warning", "fatal"],
            type: "string",
            example: "fatal",
        },
        checks: {
            type: "object",
            additionalProperties: {
                type: "string",
                description: "Whether the check is ok, or why it failed.",
                example: "failed - The debug mode was expected to be `false`, but actually was `true`",
            },
            example: {
                Redis: "ok",
                MeiliSearch: "failed - Could not reach http://localhost:7700/health.",
                UsedDiskSpace: "ok",
            },
        },
    },
};
export const OfflineCampaignSchema = {
    allOf: [
        {
            required: ["name", "starts_at", "ends_at", "event", "source_id"],
            type: "object",
            properties: {
                name: {
                    type: "string",
                    description: "Name of the event",
                    example: "The Great Event",
                },
                slug: {
                    type: "string",
                    description: "Slug for the event (must be: lowercase latin letters, digits, dash",
                    nullable: true,
                    example: "the-great-event",
                },
                starts_at: {
                    type: "string",
                    description: "Start time of the event",
                    format: "date-time",
                    example: "2024-10-12T11:05:30.0000000+00:00",
                },
                ends_at: {
                    type: "string",
                    description: "End time of the event (must be after starts_at)",
                    format: "date-time",
                    example: "2024-10-12T12:05:30.0000000+00:00",
                },
                event: {
                    type: "string",
                    description: "Event type",
                    example: "register_consumer",
                },
                source_id: {
                    type: "string",
                    description: "Source ID for the event",
                    example: "cooppronto",
                },
            },
        },
    ],
};
export const OfflineCampaignCouponRequestSchema = {
    allOf: [
        {
            required: ["offline_campaign_uuid", "format", "code"],
            type: "object",
            properties: {
                offline_campaign_uuid: {
                    type: "string",
                    description: "UUID of the associated offline campaign.",
                    example: "1e04242f-83ad-4aad-8126-1219f6f265a4",
                },
                format: {
                    enum: ["EAN8", "EAN13", "Code128"],
                    type: "string",
                    description: "The coupon's code format.",
                    example: "EAN13",
                },
                code: {
                    type: "string",
                    description: "The coupon's code in the specified format.",
                    example: "2109876543210",
                },
            },
        },
    ],
};
export const OfflineCampaignCouponSchema = {
    allOf: [
        {
            required: ["offline_campaign_uuid", "format", "code"],
            type: "object",
            properties: {
                offline_campaign_uuid: {
                    type: "string",
                    description: "UUID of the associated offline campaign.",
                    example: "1e04242f-83ad-4aad-8126-1219f6f265a4",
                },
                format: {
                    enum: ["EAN8", "EAN13", "Code128"],
                    type: "string",
                    description: "The coupon's code format.",
                    example: "EAN13",
                },
                code: {
                    type: "string",
                    description: "The coupon's code in the specified format.",
                    example: "2109876543210",
                },
                user_uuid: {
                    type: "string",
                    description: "The user who used the coupon (if any).",
                    nullable: true,
                    example: "0192b9a2-db01-7710-ba01-f75d3d1cd346",
                },
            },
        },
    ],
};
export const OrderFieldsSchema = {
    type: "object",
    properties: {
        info: {
            type: "object",
            properties: {
                order_id: {
                    type: "number",
                },
                order_status: {
                    enum: [
                        "new",
                        "confirmed",
                        "processing",
                        "pending_payment",
                        "payment_failed",
                        "payment_completed",
                        "holded",
                        "shipped",
                        "shipped_to_warehouse",
                        "delivered",
                        "delivered_to_pick_up_point",
                        "pending_cancellation",
                        "canceled",
                        "returned",
                    ],
                    type: "string",
                },
                order_date: {
                    type: "string",
                },
                total_due: {
                    type: "number",
                },
                total_item_count: {
                    type: "number",
                },
                subtotal: {
                    type: "number",
                },
                tax_total: {
                    type: "number",
                },
                shipping_amount: {
                    type: "number",
                },
                update_date: {
                    type: "string",
                },
                total: {
                    type: "number",
                },
                discount: {
                    type: "number",
                },
                shipping_amount_tax: {
                    type: "number",
                },
                order_type: {
                    type: "string",
                },
                fms_number: {
                    type: "string",
                    nullable: true,
                },
                coupons: {
                    type: "array",
                    items: {
                        type: "object",
                        properties: {
                            coupon: {
                                type: "string",
                            },
                            category: {
                                type: "string",
                            },
                        },
                    },
                },
                loyalty_campaign_id: {
                    type: "string",
                    nullable: true,
                },
                cancel_reason_code: {
                    type: "string",
                    nullable: true,
                },
                cancel_reason_message: {
                    type: "string",
                    nullable: true,
                },
                parent_id: {
                    type: "string",
                    nullable: true,
                },
                attributes: {
                    type: "object",
                },
                store_id: {
                    type: "integer",
                },
                store_name: {
                    type: "string",
                },
                total_discount: {
                    type: "number",
                },
                loyalty_campaign: {
                    type: "object",
                    properties: {
                        discounted_skus: {
                            type: "array",
                            items: {
                                type: "string",
                            },
                        },
                        spent_points: {
                            type: "number",
                        },
                        discount_amount: {
                            type: "number",
                        },
                        name: {
                            type: "string",
                            nullable: true,
                        },
                    },
                    nullable: true,
                },
            },
        },
        customer: {
            type: "object",
            properties: {
                uuid: {
                    type: "string",
                },
                email: {
                    type: "string",
                },
                first_name: {
                    type: "string",
                },
                last_name: {
                    type: "string",
                },
                phone: {
                    type: "string",
                },
                dob: {
                    type: "string",
                },
                age_verified: {
                    type: "number",
                },
            },
        },
        billing_address: {
            type: "object",
            properties: {
                entity_id: {
                    type: "number",
                },
                address_type: {
                    type: "string",
                },
                city: {
                    type: "string",
                },
                country_id: {
                    type: "string",
                },
                email: {
                    type: "string",
                },
                firstname: {
                    type: "string",
                },
                lastname: {
                    type: "string",
                },
                postcode: {
                    type: "string",
                    nullable: true,
                },
                street: {
                    type: "array",
                    items: {
                        type: "string",
                    },
                },
                telephone: {
                    type: "string",
                    nullable: true,
                },
                company: {
                    type: "string",
                    nullable: true,
                },
            },
        },
        payment: {
            type: "object",
            properties: {
                amount: {
                    type: "number",
                },
                currency: {
                    type: "string",
                },
                payment_method: {
                    type: "string",
                },
                method_title: {
                    type: "string",
                    nullable: true,
                },
                method_code: {
                    type: "string",
                    nullable: true,
                },
                method_icon: {
                    type: "string",
                    nullable: true,
                },
            },
        },
        shipping: {
            type: "object",
            properties: {
                amount: {
                    type: "number",
                },
                method: {
                    type: "string",
                    nullable: true,
                },
                address: {
                    allOf: [
                        {
                            type: "object",
                            properties: {
                                entity_id: {
                                    type: "number",
                                },
                                address_type: {
                                    type: "string",
                                },
                                city: {
                                    type: "string",
                                },
                                country_id: {
                                    type: "string",
                                },
                                email: {
                                    type: "string",
                                },
                                firstname: {
                                    type: "string",
                                },
                                lastname: {
                                    type: "string",
                                },
                                postcode: {
                                    type: "string",
                                    nullable: true,
                                },
                                street: {
                                    type: "array",
                                    items: {
                                        type: "string",
                                    },
                                },
                                telephone: {
                                    type: "string",
                                    nullable: true,
                                },
                                company: {
                                    type: "string",
                                    nullable: true,
                                },
                            },
                        },
                        {
                            type: "object",
                            properties: {
                                store_id: {
                                    type: "string",
                                    nullable: true,
                                },
                                store_name: {
                                    type: "string",
                                    nullable: true,
                                },
                            },
                            nullable: true,
                        },
                    ],
                },
            },
        },
        gift_card: {
            type: "object",
            properties: {
                base_gift_cards_amount: {
                    type: "number",
                },
                gift_cards_amount: {
                    type: "number",
                },
                gift_cards: {
                    type: "array",
                    items: {
                        type: "object",
                        properties: {
                            code: {
                                type: "string",
                            },
                            amount: {
                                type: "number",
                            },
                        },
                    },
                },
            },
        },
        taxes: {
            type: "object",
            properties: {
                base_tax_amount: {
                    type: "number",
                },
                tax_amount: {
                    type: "number",
                },
                applied_taxes: {
                    type: "array",
                    items: {
                        type: "object",
                        properties: {
                            base_amount: {
                                type: "number",
                            },
                            amount: {
                                type: "number",
                            },
                        },
                    },
                },
                item_applied_taxes: {
                    type: "array",
                    items: {
                        type: "object",
                        properties: {
                            type: {
                                type: "string",
                            },
                            item_id: {
                                type: "number",
                                nullable: true,
                            },
                            associated_item_id: {
                                type: "number",
                                nullable: true,
                            },
                            applied_taxes: {
                                type: "array",
                                items: {
                                    type: "object",
                                    properties: {
                                        base_amount: {
                                            type: "number",
                                        },
                                        amount: {
                                            type: "number",
                                        },
                                    },
                                },
                            },
                        },
                    },
                },
            },
        },
        products: {
            type: "array",
            items: {
                type: "object",
                properties: {
                    product_type: {
                        type: "string",
                    },
                    product_id: {
                        type: "number",
                    },
                    name: {
                        type: "string",
                    },
                    qty_ordered: {
                        type: "number",
                    },
                    sku: {
                        type: "string",
                    },
                    price: {
                        type: "number",
                    },
                    price_incl_tax: {
                        type: "number",
                    },
                    original_price: {
                        type: "number",
                    },
                    original_price_incl_tax: {
                        type: "number",
                    },
                    tax_amount: {
                        type: "number",
                    },
                    discount_percent: {
                        type: "number",
                    },
                    discount_amount: {
                        type: "number",
                    },
                    items: {
                        type: "array",
                        items: {
                            type: "object",
                            properties: {
                                sku: {
                                    type: "string",
                                },
                                name: {
                                    type: "string",
                                },
                                qty: {
                                    type: "number",
                                },
                                original_price: {
                                    type: "number",
                                },
                                original_price_incl_tax: {
                                    type: "number",
                                },
                                presentation_price: {
                                    type: "number",
                                    nullable: true,
                                },
                            },
                        },
                    },
                    promotional_offers: {
                        type: "array",
                        items: {
                            type: "string",
                        },
                    },
                },
            },
        },
        adjustments: {
            type: "array",
            items: {
                type: "object",
                properties: {
                    type: {
                        type: "string",
                    },
                    status: {
                        type: "string",
                    },
                    open_date: {
                        type: "string",
                    },
                    inform_warehouse: {
                        type: "boolean",
                    },
                    data: {
                        type: "object",
                        properties: {
                            order_adjustment: {
                                type: "object",
                                properties: {
                                    refund_request_id: {
                                        type: "string",
                                        nullable: true,
                                    },
                                    amount: {
                                        type: "number",
                                    },
                                    currency: {
                                        type: "string",
                                    },
                                },
                            },
                            items: {
                                type: "array",
                                items: {
                                    type: "object",
                                    properties: {
                                        sku: {
                                            type: "string",
                                        },
                                        qty: {
                                            type: "number",
                                        },
                                        requires_return: {
                                            type: "boolean",
                                        },
                                        amount: {
                                            type: "number",
                                        },
                                        currency: {
                                            type: "string",
                                        },
                                        parent_sku: {
                                            type: "string",
                                            nullable: true,
                                        },
                                    },
                                },
                            },
                        },
                    },
                },
            },
        },
    },
};
export const CreditCardSchema = {
    type: "object",
    properties: {
        uuid: {
            type: "string",
            format: "uuid",
        },
        token_uuid: {
            type: "string",
            format: "uuid",
        },
        number: {
            type: "string",
            example: "411111xxxxxx1111",
        },
        expiration_date: {
            type: "string",
            example: "01/24",
        },
        metadata: {
            type: "object",
            description: "Raw data received from the adapter",
        },
    },
};
export const PaymentMethodSchema = {
    type: "object",
    properties: {
        code: {
            type: "string",
            example: "cc",
        },
        title: {
            type: "string",
            example: "Pay with Stripe",
        },
        description: {
            type: "string",
            example: "Supports credit and debit cards, payments arrive instantly",
        },
        icon: {
            type: "string",
            nullable: true,
            example: "https://example.org/cdn/stripe-128.png",
        },
        type: {
            enum: ["online", "offline"],
            type: "string",
            example: "online",
        },
        tokenizable: {
            type: "boolean",
            example: true,
        },
        visible: {
            type: "boolean",
            example: true,
        },
        adapter_code: {
            type: "string",
            example: "stripe",
        },
    },
};
export const RefundSchema = {
    type: "object",
    properties: {
        uuid: {
            type: "string",
            format: "uuid",
        },
        order_id: {
            type: "number",
        },
        customer_uuid: {
            type: "string",
            format: "uuid",
        },
        payment_token: {
            type: "string",
            format: "uuid",
        },
        amount: {
            type: "number",
        },
        currency: {
            type: "string",
        },
        reason_code: {
            type: "string",
        },
        status: {
            enum: ["new", "processing", "done", "failed"],
            type: "string",
        },
    },
};
export const ProductSchema = {
    allOf: [
        {
            type: "object",
            properties: {
                uuid: {
                    type: "string",
                    example: "603f027f-6c5d-4084-ad10-39ac6a3aa3b6",
                },
                brand: {
                    type: "string",
                    example: "Ploom",
                },
                sku: {
                    type: "string",
                    example: "evo-mix-10-pack",
                },
                type: {
                    type: "string",
                    nullable: true,
                    example: "device",
                },
                name: {
                    type: "string",
                    nullable: true,
                    example: "EVO Mix-and-Match 10 Pack",
                },
                loyalty_rule: {
                    type: "string",
                    nullable: true,
                    example: "device_registered",
                },
            },
        },
    ],
};
export const ImportProductSchemaSchema = {
    allOf: [
        {
            type: "object",
            example: '{ "entity_id": "759", "attribute_set_id": "4", "type_id": "simple", "sku": "15125113", "has_options": "0", "required_options": "0", "created_at": "2022-12-05 11:15:50", "updated_at": "2023-08-24 14:57:47", "row_id": "759", "created_in": "1", "updated_in": "2147483647", "color": "42", "status": "1", "visibility": "4", "quantity_and_stock_status": { "is_in_stock": true, "qty": 10 }, "tax_class_id": "2", "multipacks_enabled": "0", "order_quantity_limit": "1", "enable_order_quantity_limit": "0", "flavour": null, "input_terminal": null, "description": "<p><span data-contrast=\\"none\\">Wyróżnij swoją wyjątkowość dzięki pięknym panelom przednim Ploom, które doskonale dopasują się do Twojego stylu. Zaprojektowane z taką samą starannością i uwagą jak Ploom X Advanced, panele wymienne delikatnie układają się w dłoni, zapewniając maksymalny komfort w czasie podgrzewania tytoniu i użytkowania urządzenia.<\\/span><span data-ccp-props=\\"{&quot;201341983&quot;:0,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\\"> <\\/span><\\/p>\\r\\n<ul>\\r\\n<li data-leveltext=\\"\\" data-font=\\"Symbol\\" data-listid=\\"2\\" data-list-defn-props=\\"{&quot;335552541&quot;:1,&quot;335559684&quot;:-2,&quot;335559685&quot;:720,&quot;335559991&quot;:360,&quot;469769226&quot;:&quot;Symbol&quot;,&quot;469769242&quot;:[8226],&quot;469777803&quot;:&quot;left&quot;,&quot;469777804&quot;:&quot;&quot;,&quot;469777815&quot;:&quot;multilevel&quot;}\\" aria-setsize=\\"-1\\" data-aria-posinset=\\"1\\" data-aria-level=\\"1\\"><span data-contrast=\\"none\\">Do użytku jedynie z urządzeniem Ploom X Advanced.<\\/span><span data-ccp-props=\\"{&quot;201341983&quot;:0,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\\"> <\\/span><\\/li>\\r\\n<li data-leveltext=\\"\\" data-font=\\"Symbol\\" data-listid=\\"2\\" data-list-defn-props=\\"{&quot;335552541&quot;:1,&quot;335559684&quot;:-2,&quot;335559685&quot;:720,&quot;335559991&quot;:360,&quot;469769226&quot;:&quot;Symbol&quot;,&quot;469769242&quot;:[8226],&quot;469777803&quot;:&quot;left&quot;,&quot;469777804&quot;:&quot;&quot;,&quot;469777815&quot;:&quot;multilevel&quot;}\\" aria-setsize=\\"-1\\" data-aria-posinset=\\"2\\" data-aria-level=\\"1\\"><span data-contrast=\\"none\\">Dostępne w 7 wariantach kolorystycznych.<\\/span><span data-ccp-props=\\"{&quot;201341983&quot;:0,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\\"> <\\/span><\\/li>\\r\\n<\\/ul>", "short_description": "<p>Wyróżnij swoją wyjątkowość dzięki pięknym panelom przednim Ploom, które doskonale dopasują się do Twojego stylu.<\\/p>", "meta_keyword": "Ploom X Front Panel - Ocean Blue panel", "size": "84 x 41 x 6 mm", "connectors": null, "material": "Poliwęglan", "stick_capability": null, "charging_time": null, "voltage": null, "name": "Wymienny panel niebieski Ocean Blue", "meta_title": "Wymienny panel w kolorze niebieskim Ocean Blue | Ploom X Advanced", "meta_description": "Niebieski panel wymienny do podgrzewacza tytoniu Ploom X Advanced. Wybierz swój ulubiony kolor panelu i spersonalizuj swoje urządzenie!", "image": "\\/s\\/k\\/sku0062_ploom_x_front_panel_-_ocean_blue_right_angle_vi8psmovlm6qxibf.png", "small_image": "\\/s\\/k\\/sku0062_ploom_x_front_panel_-_ocean_blue_right_angle_vi8psmovlm6qxibf.png", "thumbnail": "\\/s\\/k\\/sku0062_ploom_x_front_panel_-_ocean_blue_right_angle_vi8psmovlm6qxibf.png", "page_layout": "product-full-width", "options_container": "container2", "image_label": "Ploom X Advanced nakładka przednia morska zdjęcie z prawej\\r\\n", "small_image_label": "Ploom X Advanced nakładka przednia morska zdjęcie z prawej\\r\\n", "thumbnail_label": "Ploom X Advanced nakładka przednia morska zdjęcie z prawej\\r\\n", "url_key": "ploom-x-front-panel-ocean-blue-panel", "msrp_display_actual_price_type": "0", "gift_message_available": "2", "gift_wrapping_available": "2", "is_returnable": "2", "swatch_image": "\\/s\\/k\\/sku0062_ploom_x_front_panel_-_ocean_blue_right_angle_vi8psmovlm6qxibf.png", "battery": null, "device_dimensions": "84 x 41 x 6 mm", "multipack_label": null, "multipack_description": null, "price": "34.990000", "weight": "0.017000", "available_date": null, "options": [], "media_gallery": { "images": { "3932": { "value_id": "3932", "file": "\\/s\\/k\\/sku0062_ploom_x_front_panel_-_ocean_blue_right_angle_vi8psmovlm6qxibf.png", "media_type": "image", "row_id": "759", "label": "Ploom X Advanced nakładka przednia morska zdjęcie z prawej\\r\\n", "position": "1", "disabled": "0", "label_default": "Ploom X Advanced nakładka przednia morska zdjęcie z prawej\\r\\n", "position_default": "1", "disabled_default": "0", "video_provider": null, "video_url": null, "video_title": null, "video_description": null, "video_metadata": null, "video_provider_default": null, "video_url_default": null, "video_title_default": null, "video_description_default": null, "video_metadata_default": null }, "3933": { "value_id": "3933", "file": "\\/s\\/k\\/sku0062_ploom_x_front_panel_-_ocean_blue_front_facing_vinplmvtwngyozzz.png", "media_type": "image", "row_id": "759", "label": "Ploom X Advanced nakładka przednia morska widok z przodu\\r\\n", "position": "2", "disabled": "0", "label_default": "Ploom X Advanced nakładka przednia morska widok z przodu\\r\\n", "position_default": "2", "disabled_default": "0", "video_provider": null, "video_url": null, "video_title": null, "video_description": null, "video_metadata": null, "video_provider_default": null, "video_url_default": null, "video_title_default": null, "video_description_default": null, "video_metadata_default": null }, "3934": { "value_id": "3934", "file": "\\/s\\/k\\/sku0062_ploom_x_front_panel_-_ocean_blue_side_facing_wd_oohuac4kdp8oxsqq.png", "media_type": "image", "row_id": "759", "label": "Ploom X Advanced nakładka przednia morska zdjęcie pod kątem\\r\\n", "position": "3", "disabled": "0", "label_default": "Ploom X Advanced nakładka przednia morska zdjęcie pod kątem\\r\\n", "position_default": "3", "disabled_default": "0", "video_provider": null, "video_url": null, "video_title": null, "video_description": null, "video_metadata": null, "video_provider_default": null, "video_url_default": null, "video_title_default": null, "video_description_default": null, "video_metadata_default": null }, "3935": { "value_id": "3935", "file": "\\/s\\/k\\/sku0062_ploom_x_front_panel_-_ocean_blue_close_up_cbkw2ecvtj2umz0i.png", "media_type": "image", "row_id": "759", "label": "Ploom X Advanced nakładka przednia morska zbliżenie\\r\\n", "position": "4", "disabled": "0", "label_default": "Ploom X Advanced nakładka przednia morska zbliżenie\\r\\n", "position_default": "4", "disabled_default": "0", "video_provider": null, "video_url": null, "video_title": null, "video_description": null, "video_metadata": null, "video_provider_default": null, "video_url_default": null, "video_title_default": null, "video_description_default": null, "video_metadata_default": null }, "3936": { "value_id": "3936", "file": "\\/s\\/k\\/sku0062_ploom_x_front_panel_-_ocean_blue_texture_s31aqeibjvtna05m.png", "media_type": "image", "row_id": "759", "label": "Ploom X Advanced nakładka przednia morska tekstura\\r\\n", "position": "5", "disabled": "0", "label_default": "Ploom X Advanced nakładka przednia morska tekstura\\r\\n", "position_default": "5", "disabled_default": "0", "video_provider": null, "video_url": null, "video_title": null, "video_description": null, "video_metadata": null, "video_provider_default": null, "video_url_default": null, "video_title_default": null, "video_description_default": null, "video_metadata_default": null }, "3937": { "value_id": "3937", "file": "\\/m\\/-\\/m-sku-0062-ploom-x-front-panel-ocean-blue_jg2msondsrdddk1o.png", "media_type": "image", "row_id": "759", "label": "Ploom X Advanced nakładka przednia morska\\r\\n", "position": "6", "disabled": "0", "label_default": "Ploom X Advanced nakładka przednia morska\\r\\n", "position_default": "6", "disabled_default": "0", "video_provider": null, "video_url": null, "video_title": null, "video_description": null, "video_metadata": null, "video_provider_default": null, "video_url_default": null, "video_title_default": null, "video_description_default": null, "video_metadata_default": null } }, "values": [] }, "extension_attributes": {}, "fpt": [], "tier_price": [], "tier_price_changed": 0, "category_ids": [ "52" ], "is_salable": 1 }',
        },
    ],
};
export const eventDataSchema = {
    title: "event_data3",
    type: "object",
    properties: {
        consumer: {
            title: "consumer",
            type: "object",
            properties: {
                name: {
                    type: "string",
                    example: "John Doe",
                },
            },
            description: "Name of the review's user",
        },
    },
    description: "Single review data",
};
export const QuizSubmissionSchema = {
    type: "object",
    properties: {
        questions: {
            type: "array",
            items: {
                type: "object",
            },
            description: "Array with unspecified unvalidated payload.",
        },
        answers: {
            type: "array",
            items: {
                type: "object",
            },
            description: "Array with unspecified unvalidated payload.",
        },
        results: {
            type: "object",
            description: "Array with unspecified unvalidated payload.",
        },
    },
};
export const SearchableSchema = {
    type: "object",
    properties: {
        item_id: {
            type: "string",
            description: "Original object identifier",
            example: "PAGE-1",
        },
        type: {
            enum: ["product", "page", "faq"],
            type: "string",
            description: "Searchable item type",
            example: "page",
        },
        title: {
            type: "string",
            description: "Searchable item title",
            example: "FAQ page",
        },
        url: {
            type: "string",
            description: "Original content URL",
            example: "https://url.domain",
        },
        language: {
            type: "string",
            description: "Language two symbol code",
            example: "en",
        },
        thumbnail: {
            type: "string",
            description: "Searchable item thumbnail image",
            nullable: true,
        },
        content: {
            type: "object",
            description: "Content as JSON object",
        },
    },
};
export const SearchableResponseSchema = {
    allOf: [
        {
            type: "object",
            properties: {
                item_id: {
                    type: "string",
                    description: "Original object identifier",
                    example: "PAGE-1",
                },
                type: {
                    enum: ["product", "page", "faq"],
                    type: "string",
                    description: "Searchable item type",
                    example: "page",
                },
                title: {
                    type: "string",
                    description: "Searchable item title",
                    example: "FAQ page",
                },
                url: {
                    type: "string",
                    description: "Original content URL",
                    example: "https://url.domain",
                },
                language: {
                    type: "string",
                    description: "Language two symbol code",
                    example: "en",
                },
                thumbnail: {
                    type: "string",
                    description: "Searchable item thumbnail image",
                    nullable: true,
                },
                content: {
                    type: "object",
                    description: "Content as JSON object",
                },
            },
        },
        {
            type: "object",
            properties: {
                ranking_score: {
                    type: "number",
                    description: "Ranking score",
                    nullable: true,
                    example: 0.675,
                },
                formatted: {
                    type: "object",
                    additionalProperties: {
                        type: "string",
                    },
                    description: "Highlighted content",
                    nullable: true,
                    example: {
                        type: "page",
                        body: "Lorem Ipsum",
                        example_additional_parameter_from_content: "Some <em>additional highlighted</em> parameter from the content field",
                    },
                },
            },
        },
    ],
};
export const PaymentDetailsFieldsSchema = {
    required: ["title", "name", "icon", "brand", "funding_method"],
    type: "object",
    properties: {
        title: {
            type: "string",
            example: "Paypal",
        },
        name: {
            type: "string",
            example: "John Doe",
        },
        icon: {
            type: "string",
            nullable: true,
        },
        card_number: {
            type: "string",
            example: '"411111xxxxxx1111',
        },
        expiry: {
            type: "object",
            properties: {
                month: {
                    type: "string",
                    example: "10",
                },
                year: {
                    type: "string",
                    example: "24",
                },
            },
        },
        brand: {
            type: "string",
            example: "VISA",
        },
        funding_method: {
            type: "string",
            example: "DEBIT",
        },
    },
};
export const SubscriptionEventFieldsSchema = {
    required: ["event", "metadata", "date"],
    type: "object",
    properties: {
        event: {
            type: "string",
        },
        metadata: {
            type: "object",
            nullable: true,
        },
        date: {
            type: "string",
            format: "date-time",
            nullable: true,
        },
    },
};
export const SubscriptionHistoryEventFieldsSchema = {
    required: ["event", "metadata", "date", "type"],
    type: "object",
    properties: {
        event: {
            type: "string",
        },
        metadata: {
            type: "object",
            nullable: true,
        },
        date: {
            type: "string",
            format: "date-time",
            nullable: true,
        },
        type: {
            enum: ["internal", "external"],
            type: "string",
        },
    },
};
export const SubscriptionProductFieldsSchema = {
    required: ["sku", "qty", "options"],
    type: "object",
    properties: {
        sku: {
            type: "string",
        },
        qty: {
            type: "number",
        },
        options: {
            type: "array",
            items: {
                required: ["sku", "qty"],
                type: "object",
                properties: {
                    sku: {
                        type: "string",
                    },
                    qty: {
                        type: "number",
                    },
                },
            },
            nullable: true,
        },
    },
};
export const SubscriptionFieldsSchema = {
    type: "object",
    properties: {
        uuid: {
            type: "string",
            format: "uuid",
        },
        billed_at: {
            type: "string",
            format: "Y-m-d H:i:s",
        },
        payment_token: {
            type: "string",
            format: "uuid",
            nullable: true,
            example: "483ce128-0d2e-45f8-87c6-14c85922d020",
        },
        next_charge_at: {
            type: "string",
            format: "date-time",
            nullable: true,
        },
        amount: {
            type: "number",
        },
        currency: {
            type: "string",
        },
        status: {
            enum: ["pending", "active", "canceled", "suspended", "paused"],
            type: "string",
        },
    },
};
export const TenantCreateFieldsSchema = {
    required: ["code"],
    type: "object",
    properties: {
        code: {
            type: "string",
            description: "Tenant code",
            example: "ploom-cc",
        },
        name: {
            type: "string",
            description: "Tenant name",
            example: "Ploom CC",
        },
        country_code: {
            type: "string",
            description: "Tenant country relation",
            example: "CC",
        },
        configuration_id: {
            type: "integer",
            description: "Tenant configuration Id",
            format: "int64",
            nullable: true,
            example: 1,
        },
        database_cluster: {
            type: "string",
            description: "Tenant database cluster",
            example: "shared",
        },
        is_production: {
            type: "boolean",
            description: "Is production",
            example: false,
        },
        auto_update: {
            type: "boolean",
            description: "Enable auto update",
            example: true,
        },
        contact_person: {
            type: "string",
            description: "Name or email of the person responsible for this tenant. Automatically filled if not specified.",
            example: "john.smith@example.com",
        },
    },
};
export const TenantUpdateFieldsSchema = {
    type: "object",
    properties: {
        name: {
            type: "string",
            description: "Tenant name",
            example: "Ploom CC",
        },
        country_code: {
            type: "string",
            description: "Tenant country relation",
            example: "CC",
        },
        configuration_id: {
            type: "integer",
            description: "Tenant configuration Id",
            format: "int64",
            example: 1,
        },
        des_version: {
            type: "string",
            description: "Version",
            example: "v1",
        },
        des_previous_version: {
            type: "string",
            description: "Previous Version",
            example: "v1",
        },
        is_production: {
            type: "boolean",
            description: "Is production",
            example: false,
        },
        has_disaster_recovery_enabled: {
            type: "boolean",
            description: "Has disaster recovery",
            example: false,
        },
        auto_update: {
            type: "boolean",
            description: "Enable auto update",
            example: true,
        },
    },
};
export const TenantFieldsSchema = {
    required: ["code"],
    type: "object",
    properties: {
        code: {
            type: "string",
            description: "Tenant code",
            example: "ploom-cc",
        },
        name: {
            type: "string",
            description: "Tenant name",
            example: "Ploom CC",
        },
        country_code: {
            type: "string",
            description: "Tenant country relation",
            example: "CC",
        },
        configuration_id: {
            type: "integer",
            description: "Tenant configuration Id",
            format: "int64",
            nullable: true,
            example: 1,
        },
        des_version: {
            type: "string",
            description: "Version",
            example: "v1",
        },
        des_previous_version: {
            type: "string",
            description: "Previous Version",
            example: "v1",
        },
        database_cluster: {
            type: "string",
            description: "Tenant database cluster",
            example: "shared",
        },
        is_production: {
            type: "boolean",
            description: "Is production",
            example: false,
        },
        has_disaster_recovery_enabled: {
            type: "boolean",
            description: "Has disaster recovery enabled",
            example: false,
        },
        auto_update: {
            type: "boolean",
            description: "Enable auto update",
            example: true,
        },
        contact_person: {
            type: "string",
            description: "Name or email of the person responsible for this tenant",
            example: "john.smith@example.com",
        },
        created_at: {
            type: "string",
            description: "Record creation time",
            nullable: true,
            example: "2021-02-12T08:51:50Z",
        },
        updated_at: {
            type: "string",
            description: "Record update time",
            nullable: true,
            example: "2021-02-12T08:51:50Z",
        },
    },
};
export const TenantVersionFieldsSchema = {
    required: ["version", "has_disaster_recovery_enabled"],
    type: "object",
    properties: {
        version: {
            type: "string",
            description: "Current version",
            example: "v1",
        },
        has_disaster_recovery_enabled: {
            type: "boolean",
            description: "Has disaster recovery enabled",
            example: false,
        },
    },
};
export const ImportTenantFieldsSchema = {
    required: ["data"],
    type: "object",
    properties: {
        data: {
            type: "string",
            description: "Encrypted data of the tenant with configuration and items",
            example: "eyJpdiI6InhwV1VWNVgwUlRxSkRTNjFjL1ZFQVE9PSIsInZhbHVlIjoicjBXaGpTbk5GMlZWb2lLejlUd1FUcTFoWS9yVHRVTzAvekVaVlc5ZzN0M3ZaYWZHcjBaamF3eyJpdiI6InhwV1VWNVgwUlRxSkRTNjFjL1ZFQVE9PSIsInZhbHVlIjoicjBXaGpTbk5GMlZWb2lLejlUd1FUcTFoWS9yVHRVTzAvekVaVlc5ZzN0M3ZaYWZHcjBaamF3",
        },
        tenant_code: {
            type: "string",
            description: "Tenant code - use it if want to overwrite the code in encrypted data",
            example: "ploom-cc",
        },
        configuration_name: {
            type: "string",
            description: "Configuration name - use it if want to overwrite the code in encrypted data",
            example: "Configuration for: ploom-cc",
        },
    },
};
export const TenantSchema = {
    allOf: [
        {
            $ref: "#/components/schemas/TenantFields",
        },
    ],
};
export const TenantCreateSchema = {
    allOf: [
        {
            $ref: "#/components/schemas/TenantCreateFields",
        },
    ],
};
export const TenantVersionSchema = {
    allOf: [
        {
            $ref: "#/components/schemas/TenantVersionFields",
        },
    ],
};
export const ConfigurationItemSchema = {
    allOf: [
        {
            type: "object",
            properties: {
                id: {
                    type: "number",
                    example: 7,
                },
                configuration_id: {
                    type: "number",
                    example: 7,
                },
                is_global: {
                    type: "boolean",
                    example: false,
                },
                type: {
                    type: "string",
                    example: "messaging",
                },
                options: {
                    type: "object",
                    example: {
                        url: "http://api-evo-jtides.com",
                        secret: "secret-token-1234",
                        client: 123,
                    },
                },
                updated_at: {
                    type: "string",
                    example: "2023-12-11 10:42:00",
                },
            },
        },
    ],
};
export const ConfigurationSchema = {
    allOf: [
        {
            type: "object",
            properties: {
                id: {
                    type: "number",
                    example: 7,
                },
                name: {
                    type: "string",
                    example: "DEV PHP",
                },
                items: {
                    type: "array",
                    items: {
                        $ref: "#/components/schemas/ConfigurationItem",
                    },
                },
            },
        },
    ],
};
export const ConsumerSchema = {
    allOf: [
        {
            $ref: "#/components/schemas/ConsumerFields",
        },
    ],
};
export const ConsumerAddressFieldsSchema = {
    type: "object",
    properties: {
        id: {
            type: "integer",
            description: "Address ID",
            example: 33350,
        },
        firstname: {
            type: "string",
            description: "First name",
            nullable: true,
            example: "John",
        },
        lastname: {
            type: "string",
            description: "Last name",
            example: "Doe",
        },
        street: {
            type: "array",
            items: {
                type: "string",
            },
            description: "Street and numbers",
        },
        city: {
            type: "string",
            description: "City",
            example: "London",
        },
        postcode: {
            type: "string",
            description: "Postal code",
            nullable: true,
            example: "A8 8BN",
        },
        country_id: {
            type: "string",
            description: "Country code",
            example: "GB",
        },
        telephone: {
            type: "string",
            description: "Phone number",
            nullable: true,
            example: "+123445679",
        },
        default_shipping: {
            type: "boolean",
            description: "Address is default for shipping",
            example: true,
        },
        default_billing: {
            type: "boolean",
            description: "Address is default for billing",
            example: true,
        },
        region: {
            type: "object",
            additionalProperties: {
                type: "string",
            },
            description: "Region",
        },
        extension_attributes: {
            type: "object",
            properties: {
                subscription: {
                    type: "boolean",
                    description: "Indicates whether address is subscription address",
                    example: true,
                },
            },
            description: "Extension attributes from Magento",
            example: {
                subscription: true,
            },
        },
        administrative_area_level_2: {
            type: "string",
            description: "Second-order civil entity below the country level",
            nullable: true,
            example: "Poblacion",
        },
        sublocality_level_2: {
            type: "string",
            description: "Second-order civil entity below a locality",
            nullable: true,
            example: "Isabela",
        },
        neighborhood: {
            type: "string",
            description: "Neighborhood/Area",
            nullable: true,
            example: "Al Safa",
        },
        premise: {
            type: "string",
            description: "Building name",
            nullable: true,
            example: "Safa Heights, 12",
        },
        landmark: {
            type: "string",
            description: "Landmark & special instructions",
            nullable: true,
            example: "Near Dubai Water Canal, opposite Safa Park",
        },
        district: {
            type: "string",
            description: "District",
            nullable: true,
            example: "Dubai",
        },
        building_number: {
            type: "string",
            description: "Building number",
            nullable: true,
            example: "456B",
        },
    },
};
export const PasswordRequirementsFieldsSchema = {
    type: "object",
    properties: {
        min_length: {
            type: "integer",
            description: "Minimum length of password",
            example: 8,
        },
        min_lower_case: {
            type: "integer",
            description: "Minimum count of lower case characters in password",
            example: 1,
        },
        min_upper_case: {
            type: "integer",
            description: "Minimum count of upper case characters in password",
            example: 1,
        },
        min_number: {
            type: "integer",
            description: "Minimum count of digits in password",
            example: 1,
        },
        min_symbol: {
            type: "integer",
            description: "Minimum count of symbols (special characters) in password",
            example: 1,
        },
        exclude_username: {
            type: "boolean",
            description: `Indicates if username should be excluded from password; this also means that if your email is j.doe@a.com then you can't use letter "j" in password`,
            example: false,
        },
    },
};
export const ConsumerMetaFieldsSchema = {
    required: ["is_age_verified", "allow_date_of_birth_update"],
    type: "object",
    properties: {
        is_age_verified: {
            type: "boolean",
            description: "Indicates if consumer is age verified",
            example: false,
        },
        allow_date_of_birth_update: {
            type: "boolean",
            description: "Indicates if consumer's date of birth can be changed",
            example: false,
        },
    },
};
export const ConsumerWithAuthenticationFieldsSchema = {
    allOf: [
        {
            $ref: "#/components/schemas/ConsumerFields",
        },
        {
            required: ["authentication"],
            type: "object",
            properties: {
                authentication: {
                    $ref: "#/components/schemas/PersonalAccessTokenFields",
                },
            },
        },
    ],
};
export const authentication_method_fieldsSchema = {
    required: ["strategy", "requires_password", "registers_consumers", "logs_user_in_after_registration", "options"],
    type: "object",
    properties: {
        strategy: {
            type: "string",
            description: "The strategy slug that controls which strategy is being used for authenticating and registering users",
        },
        requires_password: {
            type: "boolean",
            description: "Whether a password needs to be provided in the authentication payload",
        },
        registers_consumers: {
            type: "boolean",
            description: "Whether this strategy can be used to register users or only authenticate them",
        },
        logs_user_in_after_registration: {
            type: "boolean",
            description: "Whether the strategy logs the user in after registration (i.e. provides an authentication token)",
        },
        options: {
            type: "object",
            description: "Additional options that will give extra information to the client that requires the authentication methods.",
        },
    },
    example: {
        strategy: "kakao-credential",
        requires_password: true,
        registers_consumers: true,
        logs_user_in_after_registration: false,
        options: {
            services_terms: "tag1,tag2",
        },
    },
};
export const CustomAttributeFieldsSchema = {
    type: "object",
    properties: {
        hint: {
            type: "string",
            description: "Hint for attribute",
            example: "Street Address",
        },
        type: {
            type: "string",
            description: "Type of attribute",
            example: "address",
        },
        label: {
            type: "string",
            description: "Label for attribute",
            example: "Street Address",
        },
        behaviour: {
            type: "array",
            items: {
                type: "string",
                example: "hidden",
            },
            description: "Behaviour of attribute",
            nullable: true,
            example: ["hidden"],
        },
        validation: {
            type: "string",
            description: "Regex for string field validation",
            nullable: true,
            example: "[0-9]{5}",
        },
        display_after: {
            type: "string",
            description: "Display after specific attribute",
            nullable: true,
            example: "custom_attributes",
        },
        is_required: {
            type: "boolean",
            description: "Indicates if attribute is required",
            example: true,
        },
        is_address_field: {
            type: "boolean",
            description: "Indicates if attribute is address field",
            example: true,
        },
        clearable: {
            type: "boolean",
            description: "Indicates whether attribute value can be cleared (this applies to an attribute that already has some value - when false it is forbidden to update to null/empty value after setting some not empty value)",
            example: true,
        },
    },
};
export const ConsumerFieldsSchema = {
    type: "object",
    properties: {
        uuid: {
            type: "string",
            description: "Consumer uuid",
            format: "uuid",
            example: "603f027f-6c5d-4084-ad10-39ac6a3aa3b6",
        },
        email: {
            type: "string",
            description: "Consumer email",
            example: "john.doe@example.com",
        },
        phone: {
            type: "string",
            description: "Consumer phone",
            nullable: true,
            example: "+48123456789",
        },
        first_name: {
            type: "string",
            description: "Consumer first name",
            example: "John",
        },
        last_name: {
            type: "string",
            description: "Consumer last name",
            example: "Doe",
        },
        date_of_birth: {
            type: "string",
            description: "Consumer birthday",
            nullable: true,
            example: "1990-11-30",
        },
        age_verification_uuid: {
            type: "string",
            description: "The age verification UUID if the user is age verified.",
            format: "uuid",
            nullable: true,
        },
        custom_attributes: {
            type: "object",
            additionalProperties: {
                type: "string",
                nullable: true,
            },
            description: "Consumer custom attributes",
            example: {
                language: "en",
                background_color: "blue",
            },
        },
        gender: {
            enum: ["male", "female", "prefer_not_to_say", null],
            type: "string",
            description: "Consumer gender",
            nullable: true,
            example: "male",
        },
        referral_code: {
            type: "string",
            description: "Consumer referral code",
            nullable: true,
            example: "bzJ0n4yRcS",
        },
        addresses: {
            type: "array",
            items: {
                $ref: "#/components/schemas/ConsumerAddressFields",
            },
            description: "Consumer addresses",
        },
        source: {
            type: "object",
            additionalProperties: {
                type: "string",
            },
            description: "Consumer source",
        },
        tracking: {
            type: "object",
            allOf: [
                {
                    $ref: "#/components/schemas/TrackingSchema",
                },
            ],
            nullable: true,
        },
    },
};
export const UsersDomainConfigurationSchema = {
    required: [
        "password_requirements",
        "custom_attributes",
        "available_authentication_strategies",
        "referrals",
        "date_of_birth_change_policy",
        "minimum_age_in_years",
    ],
    type: "object",
    properties: {
        password_requirements: {
            $ref: "#/components/schemas/PasswordRequirementsFields",
        },
        custom_attributes: {
            type: "object",
            additionalProperties: {
                $ref: "#/components/schemas/CustomAttributeFields",
            },
            example: {
                city: {
                    hint: "city",
                    type: "string",
                    label: "city",
                    behaviour: [],
                    is_required: false,
                    is_address_field: true,
                    clearable: true,
                },
                street: {
                    hint: "street",
                    type: "address",
                    label: "street",
                    behaviour: [],
                    is_required: false,
                    is_address_field: true,
                    clearable: true,
                },
                post_code: {
                    hint: "post_code",
                    type: "string",
                    label: "post_code",
                    behaviour: [],
                    is_required: false,
                    is_address_field: true,
                    clearable: true,
                },
                language: {
                    hint: "language",
                    type: "string",
                    label: "language",
                    behaviour: ["hidden"],
                    is_required: false,
                    is_address_field: false,
                    clearable: false,
                },
            },
        },
        available_authentication_strategies: {
            type: "object",
            additionalProperties: {
                $ref: "#/components/schemas/authentication_method_fields",
            },
            description: "Keyed by the strategy, this contains information about the available authentication methods.",
            example: {
                "kakao-credential": {
                    strategy: "kakao-credential",
                    requires_password: false,
                    registers_consumers: true,
                    logs_user_in_after_registration: true,
                    options: {
                        services_terms: "tag1,tag2",
                    },
                },
            },
        },
        referrals: {
            type: "object",
            properties: {
                enabled: {
                    type: "boolean",
                    description: "Status of the referrals subdomain",
                },
            },
        },
        date_of_birth_change_policy: {
            enum: ["allow", "allow_if_not_av", "deny"],
            type: "string",
            description: "Date of birth change policy",
            example: "allow",
        },
        minimum_age_in_years: {
            type: "integer",
            description: "Minimum age in years",
            example: 18,
        },
    },
};
export const KakaoCredentialStrategySchemaSchema = {
    type: "object",
    properties: {
        code: {
            type: "string",
            description: "Code fetched via Kakao OAuth redirection process",
            example: "1234567890",
        },
    },
};
export const EmailCredentialStrategySchemaSchema = {
    type: "object",
    properties: {
        identifier: {
            type: "string",
            description: "Identifier supported by email-credential strategy",
            example: "john.doe@example.com",
        },
        password: {
            type: "string",
            example: "lorem_ipsum_123",
        },
    },
};
export const PersonalAccessTokenFieldsSchema = {
    required: ["user_uuid", "token", "expires_at"],
    type: "object",
    properties: {
        user_uuid: {
            type: "string",
            description: "User uuid",
            example: "01e95725-b315-4f0a-af0c-91b03c2bf11d",
        },
        token: {
            type: "string",
            description: "Personal access token",
            example: "wefe#%%W$324sf32fsfefs564@#%%#%f",
        },
        magento_token: {
            type: "string",
            description: "Magento personal access token",
            example: "wefe#%%W$324sf32fsfefs564@#%%#%f",
        },
        expires_at: {
            type: "integer",
            description: "Date time when access token expires",
            example: 1716286013,
        },
    },
};
export const PersonalAccessTokenSchemaSchema = {
    allOf: [
        {
            $ref: "#/components/schemas/PersonalAccessTokenFields",
        },
    ],
};
export const ConsumerReportSchemaSchema = {
    allOf: [
        {
            $ref: "#/components/schemas/ConsumerReportFields",
        },
    ],
};
export const ConsumerReportFieldsSchema = {
    type: "object",
    properties: {
        uuid: {
            type: "string",
            description: "Consumer uuid",
            example: "110e8300-e29b-41d4-a711-446655440000",
        },
        email: {
            type: "string",
            description: "Consumer email",
            example: "john.doe@example.com",
        },
        phone: {
            type: "string",
            description: "Consumer phone",
            nullable: true,
            example: "+48123456789",
        },
        first_name: {
            type: "string",
            description: "Consumer first name",
            example: "John",
        },
        last_name: {
            type: "string",
            description: "Consumer last name",
            example: "Doe",
        },
        date_of_birth: {
            type: "string",
            description: "Consumer birthday",
            nullable: true,
            example: "1990-11-30",
        },
        custom_attributes: {
            type: "object",
            description: "Consumer custom attributes",
        },
        gender: {
            enum: ["male", "female", "prefer_not_to_say", null],
            type: "string",
            description: "Consumer gender",
            nullable: true,
            example: "male",
        },
        addresses: {
            type: "array",
            items: {
                $ref: "#/components/schemas/ConsumerAddressFields",
            },
            description: "Consumer addresses",
        },
        age_verification_uuid: {
            type: "string",
            description: "The age verification UUID if the user is age verified.",
            format: "uuid",
            nullable: true,
        },
        source: {
            type: "object",
            additionalProperties: {
                type: "string",
            },
            description: "Consumer source",
        },
        authentication_strategies: {
            type: "array",
            items: {
                enum: [
                    "email-credential",
                    "kakao-credential",
                    "okta-credential",
                    "okta-to-email-credential",
                    "phone-number-credential",
                    "magento-credential",
                    "magento-to-email-credential",
                ],
                type: "string",
            },
            description: "Consumer authentication strategies",
        },
        created_at: {
            type: "string",
            description: "Consumer created at",
            example: "2024-05-01 12:34:56",
        },
    },
};
export const WebhookMetaFieldsSchema = {
    type: "object",
    properties: {
        event_type: {
            type: "string",
            description: "Webhook event type",
            example: "consumer_canceled",
        },
        tenant_code: {
            type: "string",
            description: "Tenant code",
            example: "test_tenant_it",
        },
    },
};
export const WebhookFieldsSchema = {
    type: "object",
    properties: {
        id: {
            type: "integer",
            description: "Webhook identifier",
            format: "int64",
            example: 1,
        },
        event: {
            type: "string",
            description: "Webhook event",
            example: "order_created",
        },
        name: {
            type: "string",
            description: "Webhook name",
            example: "Test webhook",
        },
        description: {
            type: "string",
            description: "Webhook description",
            nullable: true,
            example: "Test webhook description",
        },
        url: {
            type: "string",
            description: "Webhook URL",
            example: "https://url.domain",
        },
        secret: {
            type: "string",
            description: "Webhook secret key",
            example: "d1b4448fe3aecf8bc7b91ffc78aa54e3193901bf3a67124c43bb00da595e8b2b",
        },
    },
};
export const WebhookSchema = {
    allOf: [
        {
            $ref: "#/components/schemas/WebhookFields",
        },
    ],
};
//# sourceMappingURL=schemas.gen.js.map